
const THREE = require('three');
const { GLTFLoader } = require("three/examples/jsm/loaders/GLTFLoader.js");
const { FBXLoader} = require("three/examples/jsm/loaders/FBXLoader.js");
const { BVHLoader} = require("three/examples/jsm/loaders/BVHLoader.js");
const { VRM, VRMHumanBoneName,VRMPose, VRMLoaderPlugin, VRMUtils } = require('@pixiv/three-vrm');
const { createVRMAnimationClip, VRMAnimationLoaderPlugin, VRMLookAtQuaternionProxy } = require( '@pixiv/three-vrm-animation');
const {WebGLRenderer} = require("three/src/renderers/WebGLRenderer.js");


const { OrbitControls } = require("three/examples/jsm/controls/OrbitControls.js");


const { mixamoVRMRigMap }= require('./mixamoVRMRigMap.js');

/////const  { loadMixamoAnimation } =  require('./loadMixamoAnimation.js');
// loadMixamoAnimation.js mixamoVRMRigMap.js をこのindex.jsと同じフォルダに置く




const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const TargetType = require('../../extension-support/target-type');
const Cast = require('../../util/cast');
const Clone = require('../../util/clone');
const Color = require('../../util/color');
const formatMessage = require('format-message');
const MathUtil = require('../../util/math-util');
const RenderedTarget = require('../../sprites/rendered-target');
const log = require('../../util/log');
const StageLayering = require('../../engine/stage-layering');

const blockIconURI = 'data:image/png;base64,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';

// eslint-disable-next-line max-len
const menuIconURI = 'data:image/png;base64,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';




const message = {
	reset: {
		'ja': '画面リセット　背景色[BG_SELECT_COLOR]',
		'en': 'Screen Reset:background-color[BG_SELECT_COLOR]'
	},
	reset2: {
		'ja': '画面リセット　背景色[BG_COLOR]',
		'en': 'Screen Reset:background-color[BG_COLOR]'
	},
	popup: {
		'ja': 'ポップアップ画面　背景色[BGCOLOR]幅[WIDTH]高さ[HEIGHT]左端[POS_X]上端[POS_Y]',
		'en': 'Popup Window:bg-color[BGCOLOR]width[WIDTH]height[HEIGHT]left[POS_X]top[POS_Y]'
	},

	add_mouse_control_text: {
		'ja': 'マウスで画面を操作',
		'en': 'Enable mouse control on screen'
	},


	img_input:{
		'ja': '画像[WORDS]URL入力(.png/.jpg/.bmp etc)',
		'en': 'Image [WORDS]input URL'
	},
	vrm_input: {
		'ja': 'VRM[WORDS] URL入力',
		'en': 'VRM[WORDS]input URL'
	},
	bvh_input: {
		'ja': 'BVH[WORDS] URL入力',
		'en': 'BVH[WORDS]input URL'
	},
	vrma_input: {
		'ja': 'VRMA[WORDS] URL入力',
		'en': 'VRMA[WORDS]input URL'
	},
	sound_input:{
		'ja': '音楽[WORDS]URL入力(.wav/.mp3)',
		'en': 'Sound[WORDS]input URL'
	},

	img_upload:{
		'ja': '画像をアップロードして表示',
		'en': 'Upload image and display'
	},
	vrm_upload:{
		'ja': 'VRMキャラクタをアップロードして表示',
		'en': 'Upload VRM file and display'
	},
	bvh_upload:{
		'ja': 'BVHモーションをアップロードして準備',
		'en': 'Upload BVH and ready to start'
	},
	vrma_upload:{
		'ja': 'VRMAモーションをアップロードして準備',
		'en': 'Upload VRMA and ready to start'
	},

	fbxmix_upload:{
		'ja': 'FBX（Mixamo ミクサモ形式）モーションをアップロードして準備',
		'en': 'Upload FBX Mixamo and ready to start'
	},

	fbx_upload:{
		'ja': 'FBXモーション(モデルあり)アップロードしてすぐに実行',
		'en': 'Upload FBX and start'
	},
	fbx_all_remove:{
		'ja': 'FBXモーション後の画像シーンの削除',
		'en': 'Remove FBX scenes'
	},


	sound_upload:{
		'ja': '音楽をアップロードして準備',
		'en': 'Upload sound and ready to start'
	},

	vrm_play_start:{
		'ja': 'BVH START. 音楽を[GAP1]秒遅らせる,モーションを[GAP2]秒遅らせる',
		'en': 'BVH START. sound delay[GAP1]sec, motion delay[GAP2]sec'
	},


	vrma_play_start:{
		'ja': 'VRMA START. 音楽を[GAP1]秒遅らせる,モーションを[GAP2]秒遅らせる',
		'en': 'VRMA START. sound delay[GAP1]sec, motion delay[GAP2]sec'
	},

	fbxmix_play_start:{
		'ja': 'FBX（Mixamo ミクサモ形式）START. 音楽を[GAP1]秒遅らせる,モーションを[GAP2]秒遅らせる',
		'en': 'FBX Mixamo START. sound delay[GAP1]sec, motion delay[GAP2]sec'
	},

	vrma_kick:{
		'ja': 'キック：+音声[SOUND_FILE]+モーション[MOTION_FILE]+サーバ[SERVER_URL]',
		'en': 'kick +Sound[SOUND_FILE]+Motion[MOTION_FILE]+Server[SERVER_URL]'
	},
	vrma_punch:{
		'ja': 'パンチ：+音声[SOUND_FILE]+モーション[MOTION_FILE]+サーバ[SERVER_URL]',
		'en': 'punch +Sound[SOUND_FILE]+Motion[MOTION_FILE]+Server[SERVER_URL]'
	},
	vrma_ue:{
		'ja': '上：+音声[SOUND_FILE]+モーション[MOTION_FILE]+サーバ[SERVER_URL]',
		'en': 'ue +Sound[SOUND_FILE]+Motion[MOTION_FILE]+Server[SERVER_URL]'
	},



	move:{
		'ja': '移動 +X[POS_X]+Y[POS_Y]+Z[POS_Z]',
		'en': 'Move +X[POS_X]+Y[POS_Y]+Z[POS_Z]'
	},
	rotation:{
		'ja': '回転 +X[ROT_X]+Y[ROT_Y]+Z[ROT_Z]',
		'en': 'Rotation +X[ROT_X]+Y[ROT_Y]+Z[ROT_Z]'
	},
	arm_set:{
		'ja': 'うでを下げる 左[LEFT_A]右[RIGHT_A]',
		'en': 'Lower arms Left[LEFT_A]Right[RIGHT_A]'
	},
	pose_reset:{
		'ja': 'ポーズをリセット',
		'en': 'Pose reset'
	},


	rotation_character:{
		'ja': '[PARTS]の角度 X[ROT_X]Y[ROT_Y]Z[ROT_Z]',
		'en': 'Angle[PARTS] X[ROT_X]Y[ROT_Y]Z[ROT_Z]'
	},


	text3d:{
		'ja':   '文字[WORDS]X[POS_X]Y[POS_Y]Z[POS_Z]',
		'en': 'Text[WORDS]X[POS_X]Y[POS_Y]Z[POS_Z]'
	},

	text2d:{
		'ja':   '文字(2D)[WORDS]X[POS_X]Y[POS_Y]',
		'en': 'Text(2D)[WORDS]X[POS_X]Y[POS_Y]'
	},


	img_sample: {
		'ja': '画像[IMG_SELECT]サンプルを選択',
		'en': 'Image[IMG_SELECT]select sample'
	},

	vrm_sample: {
		'ja': 'VRM[VRM_CHARACTER]サンプルを選択',
		'en': 'VRM[VRM_CHARACTER]select sample'
	},
	bvh_sample: {
		'ja': 'BVH[BVH_MOTION]サンプルを選択',
		'en': 'BVH[BVH_MOTION]select sample'
	},
	vrma_sample: {
		'ja': 'VRMA[VRMA_MOTION]サンプルを選択',
		'en': 'VRMA[VRMA_MOTION]select sample'
	},

	ready_before: {
		'ja': '画面準備中',
		'en': 'Please wait.....'
	},
	ready_after: {
		'ja': '準備ができました',
		'en': 'Start now'
	},

	reading_before: {
		'ja': '読み込み中',
		'en': 'Loading.....'
	},
	reading_after: {
		'ja': '読み込み終了',
		'en': 'Loading completed'
	},

	sample1: {
		'ja': 'サンプル１',
		'en': 'Sample1'
	},
	sample2: {
		'ja': 'サンプル２',
		'en': 'Sample2'
	},
	sample3: {
		'ja': 'サンプル３',
		'en': 'Sample3'
	},
	sample4: {
		'ja': 'サンプル４',
		'en': 'Sample4'
	},
	


	sample_robot:{
		'ja':'ロボ',
		'en': 'Robot'
	},
	sample_heart:{
		'ja':'ハート',
		'en': 'Heart'
	},
	sample_hanao:{
		'ja':'花尾',
		'en': 'Hanao'
	},
	sample_sennin:{
		'ja':'仙人',
		'en': 'Sennin'
	},


	col1: {
		'ja': 'しろ',
		'en': 'White'
	},
	col2: {
		'ja': 'くろ',
		'en': 'Black'
	},
	col3: {
		'ja': 'あか',
		'en': 'Red'
	},
	col4: {
		'ja': 'みどり',
		'en': 'Green'
	},
	col5: {
		'ja': 'あお',
		'en': 'Blue'
	},
	col6: {
		'ja': 'きいろ',
		'en': 'Yellow'
	},
	col7: {
		'ja': 'むらさき',
		'en': 'Purple'
	},
	col8: {
		'ja': 'みずいろ',
		'en': 'Pale blue'
	},
	col9: {
		'ja': 'あわいあか',
		'en': 'Light red'
	},
	col10: {
		'ja': 'あわいみどり',
		'en': 'Light green'
	},
	col11: {
		'ja': 'あわいあお',
		'en': 'Light blue'
	},
	col12: {
		'ja': 'うすいきいろ',
		'en': 'Light yellow'
	},
	col13: {
		'ja': 'うすいむらさき',
		'en': 'Light purple'
	},
	col14:{
		'ja': 'うすいみずいろ',
		'en': 'Light pale blue'
	}
};
// end of message jp and en



class Scratch3Character {
	constructor (runtime) {
	/**
		* The runtime instantiating this block package.
		* @type {Runtime}
	*/
		this.runtime = runtime;

		this._camera = null;
		this._scene  = null;
		this._renderer = null;

		this._stage = null;


		this._canvas_base  =  null;
		this._my_document  =  null;

		this._popup_window_flag  =  null;

		this._mouse_controls  =  null;


		this._vrm = null;

		this._vrm_x  =  null;
		this._vrm_y  =  null;
		this._vrm_z  =  null;

		this._vrm_array = new Array();

		this._bvh_array = new Array();

		this._vrma_array = new Array();

		this._ret;

		this.pose_assign  =  new Array();

		this.character_loop_flag     =   new Array();
		this.bvh_setTimeout_period   =   new Array();  // speed
		this.characters_bvh_position =   new Array();
	
		this.number_of_clip_array  =  new Array();
		this.end_of_clips_array    =  new Array();
		this.timeout_array  =  new Array();


	this.pose_assign_array = [
		[1,-1,5,3,7,9,-1,13,15,17,27,29,
			-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,
			-1,21,23,25,33,35,-1
		],
		[1,3,5,7,9,11,141,143,145,147,223,225,227,
			-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,
			93,95,97,99,193,195,197
		]
	]





this.bone_names = new Array(
	"hips",
	"spine",
	"chest",
	"upperChest",
	"neck",
	"head",
	"leftShoulder",
	"leftUpperArm",
	"leftLowerArm",
	"leftHand",
	"leftUpperLeg",
	"leftLowerLeg",
	"leftFoot",
	"leftToes",
	"leftThumbDistal",
	"leftThumbIntermediate",
	"leftThumbProximal",
	"leftIndexDistal",
	"leftIndexIntermediate",
	"leftIndexProximal",
	"leftMiddleDistal",
	"leftMiddleIntermediate",
	"leftMiddleProximal",
	"leftRingDistal",
	"leftRingIntermediate",
	"leftRingProximal",
	"leftLittleDistal",
	"leftLittleIntermediate",
	"leftLittleProximal",
	"leftEye",
	"rightShoulder",
	"rightUpperArm",
	"rightLowerArm",
	"rightHand",
	"rightUpperLeg",
	"rightLowerLeg",
	"rightFoot",
	"rightToes",
	"rightThumbDistal",
	"rightThumbIntermediate",
	"rightThumbProximal",
	"rightIndexDistal",
	"rightIndexIntermediate",
	"rightIndexProximal",
	"rightMiddleDistal",
	"rightMiddleIntermediate",
	"rightMiddleProximal",
	"rightRingDistal",
	"rightRingIntermediate",
	"rightRingProximal",
	"rightLittleDistal",
	"rightLittleIntermediate",
	"rightLittleProximal",
	"rightEye");
	


		this._parameter_init(this);
	
	}
	// end of constructor


_parameter_init(t){
	t._render_flg  =  0;

	t._vrm    =  null;
	t._vmd    =  null;

	t._img_file_name =  null;
	t._vrm_file_name =  null;
	t._bvh_file_name =  null;
	t._vrma_file_name =  null;

	t._fbx_file_name =  null;
	t._fbxmix_file_name =  null;


	t._vrma_file =  null;


	t._fbx_object_array = {};

	t._sound_file_data =  null;
	t._sound_file_name =  null;


	t._clock          =  null;
	t._animation_flg  =  null;

	t._next_currentMixer = null;

	t._set_time_counter =0;


	t._fbx_animation_flg = false;
}


/*
The following sites were referred for multilingual text:

https://scratch3-tello.app/ja/docs/development/i18n/
https://github.com/kebhr/scratch3-tello/blob/master/scratch-vm/src/extensions/scratch3_tello/index.js

*/



	_getText (key) {
	console.log("key",key);
		return message[key][this.locale] || message[key]['en'];
	}


	getInfo () {

		const current_locale = formatMessage.setup().locale;
		if (Object.keys(message).filter((key) => {return current_locale in message[key]}).length > 0) {
			this.locale = current_locale;
		}else{
			this.locale = 'en';
		}




		this.make_window_process("#ffffff");


		return {
			id: 'character',
			name: 'Chara-Zou',
			menuIconURI: menuIconURI,
			blockIconURI: blockIconURI,

			blocks: [

				{
					opcode: 'make_window',
					text:  this._getText('reset'), 
					arguments: {
						 BG_SELECT_COLOR:{
							type: ArgumentType.NUMBER,
							menu: 'BG_SELECT_COLOR',
							defaultValue: 1
						}
					}
				},
				{
					opcode: 'make_window2',
					text:   this._getText('reset2'), 
					arguments: {
						BG_COLOR: {
							type: ArgumentType.STRING,
							defaultValue: "#eeeeff"
						}
					}
				},


				{
					opcode: 'popup_window',
					text: this._getText('popup'),
					arguments: {
						POS_X: {
							type: ArgumentType.NUMBER,
							defaultValue: 800
						},
						POS_Y: {
							type: ArgumentType.NUMBER,
							defaultValue: 100
						},
						WIDTH: {
							type: ArgumentType.NUMBER,
							defaultValue: 600
						},
						HEIGHT: {
							type: ArgumentType.NUMBER,
							defaultValue: 400
						},
						BGCOLOR: {
							type: ArgumentType.NUMBER,
							menu: 'BG_SELECT_COLOR',
							defaultValue: 1
						}
					}
				},


				{
					 opcode: 'add_mouse_control',
					 blockType: BlockType.COMMAND,
					 text:  this._getText('add_mouse_control_text'),
				},



				{
					 opcode: 'img_button_click',
					 blockType: BlockType.COMMAND,
					 text:  this._getText('img_upload'),
				},
				{
					 opcode: 'vrm_button_click',
					 blockType: BlockType.COMMAND,
					 text:  this._getText('vrm_upload'), 
				},
				{
					 opcode: 'bvh_button_click',
					 blockType: BlockType.COMMAND,
					 text:  this._getText('bvh_upload'),
				},
				{
					 opcode: 'vrma_button_click',
					 blockType: BlockType.COMMAND,
					 text:  this._getText('vrma_upload'),
				},
				{
					 opcode: 'fbxmix_button_click',
					 blockType: BlockType.COMMAND,
					 text:  this._getText('fbxmix_upload'),
				},
				{
					 opcode: 'fbx_button_click',
					 blockType: BlockType.COMMAND,
					 text:  this._getText('fbx_upload'),
				},
				{
					 opcode: 'fbx_all_remove',
					 blockType: BlockType.COMMAND,
					 text:  this._getText('fbx_all_remove'),
				},
				{
					 opcode: 'sound_button_click',
					 blockType: BlockType.COMMAND,
					 text:  this._getText('sound_upload'),
				},
				{
					 opcode: 'vrm_play_button_click',
					 blockType: BlockType.COMMAND,
					 text: this._getText('vrm_play_start'), 
					 arguments: {
						GAP1: {
							type: ArgumentType.NUMBER,
							defaultValue: 0
						},
						GAP2: {
							type: ArgumentType.NUMBER,
							defaultValue: 0
						}
					 }
				},
				{
					 opcode: 'vrma_play_button_click',
					 blockType: BlockType.COMMAND,
					 text: this._getText('vrma_play_start'), 
					 arguments: {
						GAP1: {
							type: ArgumentType.NUMBER,
							defaultValue: 0
						},
						GAP2: {
							type: ArgumentType.NUMBER,
							defaultValue: 0
						}
					 }
				},

				{
					 opcode: 'fbxmix_play_button_click',
					 blockType: BlockType.COMMAND,
					 text: this._getText('fbxmix_play_start'), 
					 arguments: {
						GAP1: {
							type: ArgumentType.NUMBER,
							defaultValue: 0
						},
						GAP2: {
							type: ArgumentType.NUMBER,
							defaultValue: 0
						}
					 }
				},
				{
					 opcode: 'stop_button_click',
					 blockType: BlockType.COMMAND,
					 text:  'STOP'
				},


				{
					 opcode: 'file_check',
					 blockType: BlockType.COMMAND,
					 text:  'Check Files'
				},

				{
					opcode: 'img_url_read',
					text:    this._getText('img_input'),
					arguments: {
						WORDS: {
							type: ArgumentType.STRING,
							defaultValue: "https://social-exp.site/scratch_contents/image/sample1.png"
						  }
					}
				},
				{
					opcode: 'vrm_url_read',
					text:    this._getText('vrm_input'),
					arguments: {
						WORDS: {
							type: ArgumentType.STRING,
							defaultValue: "https://social-exp.site/cc/c2021_10_no1.vrm"
						  }
					}
				},
				{
					opcode: 'bvh_url_read',
					text:  this._getText('bvh_input'),
					arguments: {
						WORDS: {
							type: ArgumentType.STRING,
							defaultValue: "https://social-exp.site/scratch_contents/bvh/sample1_hand.bvh"
						  }
					}
				},
				{
					opcode: 'vrma_url_read',
					text:  this._getText('vrma_input'),
					arguments: {
						WORDS: {
							type: ArgumentType.STRING,
							defaultValue: "https://social-exp.site/scratch_contents/vrma/sample1_enka.vrma"
						  }
					}
				},
				{
					opcode: 'sound_url_read',
					text:    this._getText('sound_input'),
					arguments: {
						WORDS: {
							type: ArgumentType.STRING,
							defaultValue: "      .wav/.mp3 etc"
						  }
					}
				},


				{
					 opcode: 'move_vrm',
					 blockType: BlockType.COMMAND,
					 text:  this._getText('move'),
					 arguments: {
						POS_X: {
							type: ArgumentType.NUMBER,
							defaultValue: 0
						},
						POS_Y: {
							type: ArgumentType.NUMBER,
							defaultValue: 0
						},
						POS_Z: {
							type: ArgumentType.NUMBER,
							defaultValue: 0
						}
					 }
				},
				{
					 opcode: 'rotate_vrm',
					 blockType: BlockType.COMMAND,
					 text: this._getText('rotation'),
					 arguments: {
						  ROT_X: {
							type: ArgumentType.NUMBER,
							defaultValue: 0
						},
						  ROT_Y: {
							type: ArgumentType.NUMBER,
							defaultValue: 0
						},
						  ROT_Z: {
							type: ArgumentType.NUMBER,
							defaultValue: 0
						}
					 }
				},
				{
					opcode: 'arm_set',
					text:  this._getText('arm_set'),
					arguments: {
						LEFT_A: {
							type: ArgumentType.NUMBER,
							defaultValue: 75
						},
						RIGHT_A: {
							type: ArgumentType.NUMBER,
							defaultValue: -75
						}
					}
				},

				{
					opcode: 'pose_set',
					text:  this._getText('pose_reset')
				},

				{
					 opcode: 'parts',
					 blockType: BlockType.COMMAND,
					 text:  this._getText('rotation_character'),
					 arguments: {
						PARTS:{
							type: ArgumentType.NUMBER,
							menu: 'PARTS',
							defaultValue: 1
						},
						  ROT_X: {
							type: ArgumentType.NUMBER,
							defaultValue: 0
						},
						  ROT_Y: {
							type: ArgumentType.NUMBER,
							defaultValue: 0
						},
						  ROT_Z: {
							type: ArgumentType.NUMBER,
							defaultValue: 0
						}
					}
				},


				{
					opcode: 'display_text',
					text:   this._getText('text3d'),
					arguments: {
						WORDS: {
							type: ArgumentType.STRING,
							defaultValue: "ABC"
						  },
						POS_X: {
							type: ArgumentType.NUMBER,
							defaultValue: 0.5
						},
						POS_Y: {
							type: ArgumentType.NUMBER,
							defaultValue: 0.5
						},
						POS_Z: {
							type: ArgumentType.NUMBER,
							defaultValue: -0.5
						}
					}
				},
				{
					opcode: 'display_text2d',
					text:    this._getText('text2d'),
					arguments: {
						WORDS: {
							type: ArgumentType.STRING,
							defaultValue: "ABC"
						  },
						POS_X: {
							type: ArgumentType.NUMBER,
							defaultValue: 0
						},
						POS_Y: {
							type: ArgumentType.NUMBER,
							defaultValue: 1
						}
					}
				},




				{
					opcode: 'img_select',
					text: this._getText('img_sample'),
					arguments: {
						IMG_SELECT: {
							type: ArgumentType.NUMBER,
							menu: 'SELECT_IMG',
							defaultValue: 1
						}
					}
				},
				{
					opcode: 'vrm_select',
					text: this._getText('vrm_sample'),
					arguments: {
						VRM_CHARACTER: {
							type: ArgumentType.NUMBER,
							menu: 'SELECT_VRM_CHARACTER',
							defaultValue: 1
						}
					}
				},
				{
					opcode: 'bvh_select',
					text:   this._getText('bvh_sample'),
					arguments: {
						BVH_MOTION: {
							type: ArgumentType.NUMBER,
							menu: 'SELECT_BVH_MOTION',
							defaultValue: 1
						  }
					}
				},


				{
					opcode: 'vrma_select',
					text:   this._getText('vrma_sample'),
					arguments: {
						VRMA_MOTION: {
							type: ArgumentType.NUMBER,
							menu: 'SELECT_VRMA_MOTION',
							defaultValue: 1
						  }
					}
				},


				{
					 opcode: 'vrma_kick_button_click',
					 blockType: BlockType.COMMAND,
					 text:  this._getText('vrma_kick'),
					 arguments: {
						SOUND_FILE: {
							type: ArgumentType.STRING,
							defaultValue: "kick0910.wav"
						  },
						MOTION_FILE: {
							type: ArgumentType.STRING,
							defaultValue: "kick0910.vrma"
						  },
						SERVER_URL: {
							type: ArgumentType.STRING,
							defaultValue: "http://localhost/parts/"
						  }
					}
				},
				{
					 opcode: 'vrma_punch_button_click',
					 blockType: BlockType.COMMAND,
					 text:  this._getText('vrma_punch'),
					 arguments: {
						SOUND_FILE: {
							type: ArgumentType.STRING,
							defaultValue: "punch0910.wav"
						  },
						MOTION_FILE: {
							type: ArgumentType.STRING,
							defaultValue: "punch0910.vrma"
						  },
						SERVER_URL: {
							type: ArgumentType.STRING,
							defaultValue: "http://localhost/parts/"
						  }
					}
				},
				{
					 opcode: 'vrma_ue_button_click',
					 blockType: BlockType.COMMAND,
					 text:  this._getText('vrma_ue'),
					 arguments: {
						SOUND_FILE: {
							type: ArgumentType.STRING,
							defaultValue: "ue0910.wav"
						  },
						MOTION_FILE: {
							type: ArgumentType.STRING,
							defaultValue: "ue0910.vrma"
						  },
						SERVER_URL: {
							type: ArgumentType.STRING,
							defaultValue: "http://localhost/parts/"
						  }
					}
				}






			],

			menus: {
				PARTS: {
					acceptReporters: true,                         /// ?????????????
					items: this._makeMenu(this.PARTS_INFO)
				},

				SELECT_IMG: {
					acceptReporters: true,
					items: this._makeMenu(this.SELECT_IMG_INFO)
				},
				SELECT_VRM_CHARACTER: {
					acceptReporters: true,
					items: this._makeMenu(this.VRM_CHARACTER_INFO)
				},
				SELECT_BVH_MOTION: {
					acceptReporters: true,
					items: this._makeMenu(this.BVH_MOTION_INFO)
				},
				SELECT_VRMA_MOTION: {
					acceptReporters: true,
					items: this._makeMenu(this.VRMA_MOTION_INFO)
				},
				BG_SELECT_COLOR: {
					acceptReporters: true,
					items: this._makeMenu(this.BG_SELECT_COLOR_INFO)
				}
			}

		};
	}


_makeMenu(info){
	return info.map((entry, index) => {
		let obj = {};
		obj.text = entry.name;
		obj.value = String(index + 1);
		return obj;
	});
}


get PARTS_INFO () {
		return [
{name:'hips'},
{name:'spine'},
{name:'chest'},
{name:'upperChest'},
{name:'neck'},
{name:'head'},
{name:'leftShoulder'},
{name:'leftUpperArm'},
{name:'leftLowerArm'},
{name:'leftHand'},
{name:'leftUpperLeg'},
{name:'leftLowerLeg'},
{name:'leftFoot'},
{name:'leftToes'},
{name:'leftThumbDistal'},
{name:'leftThumbIntermediate'},
{name:'leftThumbProximal'},
{name:'leftIndexDistal'},
{name:'leftIndexIntermediate'},
{name:'leftIndexProximal'},
{name:'leftMiddleDistal'},
{name:'leftMiddleIntermediate'},
{name:'leftMiddleProximal'},
{name:'leftRingDistal'},
{name:'leftRingIntermediate'},
{name:'leftRingProximal'},
{name:'leftLittleDistal'},
{name:'leftLittleIntermediate'},
{name:'leftLittleProximal'},
{name:'leftEye'},
{name:'rightShoulder'},
{name:'rightUpperArm'},
{name:'rightLowerArm'},
{name:'rightHand'},
{name:'rightUpperLeg'},
{name:'rightLowerLeg'},
{name:'rightFoot'},
{name:'rightToes'},
{name:'rightThumbDistal'},
{name:'rightThumbIntermediate'},
{name:'rightThumbProximal'},
{name:'rightIndexDistal'},
{name:'rightIndexIntermediate'},
{name:'rightIndexProximal'},
{name:'rightMiddleDistal'},
{name:'rightMiddleIntermediate'},
{name:'rightMiddleProximal'},
{name:'rightRingDistal'},
{name:'rightRingIntermediate'},
{name:'rightRingProximal'},
{name:'rightLittleDistal'},
{name:'rightLittleIntermediate'},
{name:'rightLittleProximal'},
{name:'rightEye'}

		]
}


get SELECT_IMG_INFO(){
	return [
		{name:this._getText('sample1') },
		{name:this._getText('sample2') },
		{name:this._getText('sample3') }
	]
}

get VRM_CHARACTER_INFO(){
	return [
		{name: this._getText('sample_robot')},
		{name: this._getText('sample_heart')},
		{name: this._getText('sample_hanao')},
		{name: this._getText('sample_sennin')}
	]
}

get BVH_MOTION_INFO(){
	return[
		{name:'sample1_hand.bvh'},
		{name:'sample2_rot_left.bvh'},
		{name:'sample3_rot_right.bvh'}
	]

}

get VRMA_MOTION_INFO(){
	return[
		{name:'sample1_enka.vrma'},
		{name:'sample2_opera.vrma'},
		{name:'sample3_idol.vrma'}
	]

}

get BG_SELECT_COLOR_INFO(){
	return [
		{name:this._getText('col1') },
		{name:this._getText('col2') },

		{name:this._getText('col3') },
		{name:this._getText('col4') },
		{name:this._getText('col5') },

		{name:this._getText('col6') },
		{name:this._getText('col7') },
		{name:this._getText('col8') },

		{name:this._getText('col9') },
		{name:this._getText('col10') },
		{name:this._getText('col11') },

		{name:this._getText('col12') },
		{name:this._getText('col13') },
		{name:this._getText('col14') }
	]
}


file_check(){

	this._display_text2d(10, 10, this._img_file_name,  "id1" );
	this._display_text2d(10, 90, this._vrm_file_name,  "id2" );
	this._display_text2d(10, 170, this._bvh_file_name,  "id3" );

	this._display_text2d(10, 250, this._vrma_file_name,  "id4" );

	this._display_text2d(10, 280, this._sound_file_name,"id5" );

	let my_t = this;

	setTimeout(function (){
		my_t._delete_text("id1",my_t);
		my_t._delete_text("id2",my_t);
		my_t._delete_text("id3",my_t);
		my_t._delete_text("id4",my_t);
		my_t._delete_text("id5",my_t);
	}, 5000);

}


_delete_text(id, t){

	let my_id;

	if(this._popup_window_flag==1){
		my_id = t._my_document.getElementById(id);
	}else{
		my_id = document.getElementById(id);
	}

	if(my_id != null){
		my_id.innerHTML="";
	}
}


_display_text2d(this_x,this_y,this_text, id){
	let this_csn	=  this._scene;
	let this_cam	=  this._camera;
	let this_rend	=  this._renderer;

	let this_canvas = this._canvas;

	let div_tmp;
	if(this._popup_window_flag==1){
		div_tmp = this._my_document.getElementById(id);
	}else{
		div_tmp = document.getElementById(id);
	}

	if(div_tmp == null){
		div_tmp        =  document.createElement('div');
		div_tmp.id  =  id;
	}
	div_tmp.style      =  "position:absolute; top:"+this_y+"px ; left:"+this_x+"px";
	div_tmp.innerHTML  =  this_text;

	if(this._popup_window_flag==1){
		this._canvas_base.appendChild(div_tmp);
	}else{
////		let standard_window  =  document.getElementsByClassName("stage_stage-bottom-wrapper_fnczd")[0];

 	let standard_window  =  document.getElementsByClassName("stage_stage-bottom-wrapper_vRJed")[0];
		standard_window.appendChild(div_tmp);
	}
}



add_mouse_control(){

	if(this._stage == null  || this._stage == 2 ){
		return;
	}
	
	let load_counter = 0;
	let load_script_filename = new Array();

/*
	if(this._popup_window_flag == 1){
		load_script_filename[load_counter++] =	'https://m-asyua.github.io/scratch_contents/OrbitControls.js'
	}else{
		load_script_filename[load_counter++] = 'https://m-asyua.github.io/scratch_contents/OrbitControls_rev1.js';  //!!!!!!!!!
	}

	this.load_js_files(load_script_filename, mouse_process2,this);
*/
mouse_process2(this);

	function mouse_process2(t){

		t._text_display("");

//this_object._my_document = newWin.document;

		let this_csn   =  t._scene;
		let this_cam   =  t._camera;
		let this_rend  =  t._renderer;


		let mouse_controls = new OrbitControls(   this_cam,    t._canvas_base);
		mouse_controls.target.set(0,0,-2 ); 	
//		mouse_controls.update(delta);
		mouse_controls.addEventListener('change',  camera_rendering );  // not use animate();

		function camera_rendering(){

			console.log("set_camera(",
				my_round( this_cam.position.x,4),  ",",
				my_round( this_cam.position.y,4),  ",", 
				my_round( this_cam.position.z,4),  ",",
				my_round( this_cam.rotation.x,4),  ",",
				my_round( this_cam.rotation.y,4),  ",",
				my_round( this_cam.rotation.z,4),  ",15 " // <- fov
			 );
/*
		console.log("camera_look_at(",
			my_round( mouse_controls.target.x,4),  ",",
			my_round( mouse_controls.target.y,4),  ",",
			my_round( mouse_controls.target.z,4),  ")",
		);
*/

			this_rend.render(this_csn, this_cam);

			function my_round(num, n){
				return Math.floor( num * Math.pow( 10, n ) ) / Math.pow( 10, n ) ;
			}

		}
	}



}


img_select(args){

	let num = args.IMG_SELECT;
	let file_name_array =[
		"https://social-exp.site/scratch_contents/image/sample1.png",
		"https://social-exp.site/scratch_contents/image/sample2.png",
		"https://social-exp.site/scratch_contents/image/sample3.png"
	]

	this.img_url_read_file( file_name_array[num-1], this);

}


vrm_select(args){
	let num = args.VRM_CHARACTER;
	let vrm_file_name_array =[
		"https://social-exp.site/cc/c2021_10_no29.vrm", 
		"https://social-exp.site/cc/c2021_12_no5.vrm",  
		"https://social-exp.site/cc/c2021_10_no2.vrm",  
		"https://social-exp.site/cc/c2021_10_no1.vrm"   
	]

	this.vrm_ready(vrm_file_name_array[num-1]);

}


vrma_select(args){

	let num = args.VRMA_MOTION;

	let vrma_files = [
		'sample1_enka.vrma',
		'sample2_opera.vrma',
		'sample3_idol.vrma'
	];

	let file_url_name =  "https://social-exp.site/scratch_contents/vrma/"+vrma_files[num-1];


	this._vrma_file_name = file_url_name;

	this.load_vrma(file_url_name);

}


load_vrma ( file_url){


	let gltf_loader = new GLTFLoader();
	gltf_loader.crossOrigin = 'anonymous';


	gltf_loader.register((parser) => {
		 return new VRMLoaderPlugin(parser);
	});

	gltf_loader.register((parser) => {
		return  new VRMAnimationLoaderPlugin(parser);
	});



	let my_t = this;


	gltf_loader.load(file_url, ( gltf ) => {

		my_t._vrma_file   = gltf;

//alert("vrma:", file_url,  my_t._vrma_file);

		},
		( progress ) => console.log( 'Loading vrma:', 100.0 * ( progress.loaded / progress.total ), '%' ),
		( error ) => alert( error )
	);



}

load_vrma2 ( file_url){


	let gltf_loader = new GLTFLoader();
	gltf_loader.crossOrigin = 'anonymous';


	gltf_loader.register((parser) => {
		 return new VRMLoaderPlugin(parser);
	});

	gltf_loader.register((parser) => {
		return  new VRMAnimationLoaderPlugin(parser);
	});



	let my_t = this;


	gltf_loader.load(file_url, ( gltf ) => {

		my_t._vrma_file   = gltf;

//alert("vrma:", file_url,  my_t._vrma_file);

my_t.my_execute_vrma(my_t._vrma_file, my_t);

		},
		( progress ) => console.log( 'Loading vrma2:', 100.0 * ( progress.loaded / progress.total ), '%' ),
		( error ) => alert( error )
	);



}





vrma_punch_button_click(args){
		this.vrma_kick_button_click(args);
	}

vrma_ue_button_click(args){
		this.vrma_kick_button_click(args);
	}


vrma_kick_button_click(args){

	let sound_file   = args.SOUND_FILE;
	let motion_file  = args.MOTION_FILE;
	let server_url = args.SERVER_URL;

	let sound_file_data = new Audio();
	    sound_file_data.src= server_url+"/"+sound_file;



//
//ここからモーションファイルも読み取って再生
//////alert(server_url+"/"+motion_file);

	this.load_vrma2(server_url+  motion_file);

	sound_file_data.play();

//	this.execute_vrma( this._vrma_file  , this );


}


fbxmix_play_button_click(args){

	if(this._stage == null  || this._stage == 2 ){  return; }

	let my_t = this;

	let gap1 = args.GAP1;
	let gap2 = args.GAP2;

console.log("gap1,gap2=",gap1,gap2);

	let this_csn		=  this._scene;
	let this_cam		=  this._camera;
	let this_rend		=  this._renderer;

	if(this._sound_file_data!=null){
		setTimeout( function(){
			my_t._sound_file_data.play();
		}, gap1*1000 );
	}

/*
	if(  this._bvh_array   ==  null){
		console.log("bvh is null, it does not work:", this._vmd);
		return;
	}
*/


	setTimeout( function(){

		try{

			my_t.load_fbxmix(my_t._fbx_content,  my_t);

		}catch(e){
			alert(e);
		}

	}, gap2*1000 );



}




vrma_play_button_click(args){

	if(this._stage == null  || this._stage == 2 ){  return; }


if(this.play_button_enabled ==1){return;}

	let gap1 = args.GAP1;
	let gap2 = args.GAP2;

console.log("gap1,gap2=",gap1,gap2);


	let my_t = this;

	let this_csn		=  this._scene;
	let this_cam		=  this._camera;
	let this_rend		=  this._renderer;


	if(this._sound_file_data!=null){
		setTimeout( function(){
			my_t._sound_file_data.play();
		}, gap1*1000 );
	}




/*
	if(  this._bvh_array   ==  null){
		console.log("bvh is null, it does not work:", this._vmd);
		return;
	}
*/



	setTimeout( function(){

		try{

			my_t.execute_vrma( my_t._vrma_file  , this );
								

		}catch(e){
			alert(e);
		}

	}, gap2*1000 );
}







my_execute_vrma(vrma_data, t){


	let my_t = this;










	my_t._clock = new THREE.Clock();
	my_t._clock.start();

	my_t._animation_flg = 0;


	let currentVrm = 	my_t._vrm;

if(currentVrm ==null || my_t._vrma_file == null){
	if(my_t._set_time_counter < 100){
		setTimeout(function (){
				my_t._set_time_counter++;
				my_t.my_execute_vrma(vrma_data, t);
			} , 100);
	}else{
		my_t._set_time_counter =0;
	}
}



	let next_vrmAnimations = my_t._vrma_file.userData.vrmAnimations;




	my_t._next_currentMixer = new THREE.AnimationMixer( currentVrm.scene );

	let next_currentVrmAnimation = next_vrmAnimations[ 0 ] ?? null;
	let next_clip = createVRMAnimationClip( next_currentVrmAnimation, currentVrm );

	let my_clip_action = my_t._next_currentMixer.clipAction( next_clip );





	my_clip_action.setLoop(THREE.LoopOnce); // 1回だけ再生
	my_clip_action.clampWhenFinished = true; //最後にポーズで終わる



///	next_currentMixer.timeScale = params.timeScale;
	my_t._next_currentMixer.timeScale = 1;





	my_t._animation_flg = 1; //ここでONにする


	my_t._next_currentMixer.addEventListener('finished', function(e) {
		console.log("mixer finished");
		my_clip_action.paused = true; 
		my_t._animation_flg = 0;
		// ポーズそのままで他のアクションができなくなるので対策
	} );
	
	
	my_t.animate(this);
	my_clip_action.play();




}






execute_vrma(vrma_data, t){


	let my_t = this;






	my_t._clock = new THREE.Clock();
	my_t._clock.start();

	my_t._animation_flg = 0;


	let currentVrm = 	my_t._vrm;

if(currentVrm ==null || my_t._vrma_file == null){
	if(my_t._set_time_counter < 100){
		setTimeout(function (){
				my_t._set_time_counter++;
				my_t.execute_vrma(vrma_data, t);
			} , 100);
	}else{
		my_t._set_time_counter =0;
	}
}

	let next_vrmAnimations = my_t._vrma_file.userData.vrmAnimations;


	my_t._next_currentMixer = new THREE.AnimationMixer( currentVrm.scene );

	let next_currentVrmAnimation = next_vrmAnimations[ 0 ] ?? null;
	let next_clip = createVRMAnimationClip( next_currentVrmAnimation, currentVrm );

	let my_clip_action = my_t._next_currentMixer.clipAction( next_clip );


	my_clip_action.setLoop(THREE.LoopOnce); // 1回だけ再生
	my_clip_action.clampWhenFinished = true; //最後にポーズで終わる



///	next_currentMixer.timeScale = params.timeScale;
	my_t._next_currentMixer.timeScale = 1;

	my_t._animation_flg = 1; //ここでONにする


	my_t._next_currentMixer.addEventListener('finished', function(e) {
		console.log("mixer finished");
		my_clip_action.paused = true; 
		my_t._animation_flg = 0;
		// ポーズそのままで他のアクションができなくなるので対策
	} );

	my_t.animate(this);

	my_clip_action.play();


}





animate(t) {

	let my_t = this;
	if(my_t._animation_flg == 0){return;}//対応


	//ここが原因？
	requestAnimationFrame( tmp    );

function tmp(){
	my_t.animate(this);
}

let mc = my_t._clock;

	if(my_t._animation_flg == 0){
	}else{

		let deltaTime = mc.getDelta();

		if ( my_t._next_currentMixer ) {
			my_t._next_currentMixer.update( deltaTime );
		}

		if ( my_t._vrm ) {
			my_t._vrm.update( deltaTime );
		}
/*
		vrm_rot_Hips( 0,  
			characters_rotation[0][0],
			characters_rotation[0][1],
			characters_rotation[0][2]
		);	
*/


///		renderer.render( scene, camera );

	let this_csn		=  this._scene;
	let this_cam		=  this._camera;
	let this_rend		=  this._renderer;


				this_rend.render(this_csn, this_cam);




	}
}



////////////////













bvh_select(args){

	let file_name = "";
	let num = args.BVH_MOTION;

	let bvh_files = [
		'sample1_hand.bvh',
		'sample2_rot_left.bvh',
		'sample3_rot_right.bvh'
	];

	file_name = "https://social-exp.site/scratch_contents/bvh/"+bvh_files[num-1];


	this._bvh_file_name = file_name;

	this.bvh_url_read_file(file_name, this);

}











bvh_url_read(arg){
	this.bvh_url_read_file(arg.WORDS, this);
}



bvh_url_read_file(input_file_name,t ){

// fetchで対応

	let my_t = this;

	// load BVH file
	fetch(input_file_name).then(function(response) {

		my_t._bvh_file_name = input_file_name;
		response.text().then(function(text) {
			//my_d.load_bvh_option(nickname, input_file_name, loop_flg, pose_assign_num, wait_time, bx, by, bz,hip_position_flag, hip_rotation_flag, head_flag,  bvh_scale )
			t.load_bvh_option(        "tmp",  text ,           0,                    0  , 10, 0 ,-0.88 ,0,     0, 0,0,   0.004  );
		});
	});


}


vrma_url_read(arg){
	this.vrma_url_read_file(arg.WORDS, this);
}



vrma_url_read_file(input_file_name,t ){

	let my_t = this;
	my_t.load_vrma(input_file_name);

/*
// fetchで対応

	let my_t = this;

	// load VRMA file
	fetch(input_file_name).then(function(response) {

		my_t._vrma_file_name = input_file_name;
		response.text().then(function(text) {
			t.load_vrma2(text);
		});
	});
*/

}





vrm_url_read(args){
	this.vrm_main(this,               args.WORDS, 0.8,   null);
}

vrm_ready(vrm_file_name){
	this.vrm_main(this,               vrm_file_name, 0.8);
}

vrm_main(t, vrm_file_name, vrm_scale){
	t._vrm  =  null;
	t.vrm_main2(vrm_file_name, vrm_scale, t);
}

vrm_main2(vrm_file_name, vrm_scale,t){

	t._text_display("Please wait...."+ vrm_file_name +".....");


let this_vrm = null;
t._vrm = null;


this._vrm_file_name  =  vrm_file_name;


console.log("vrm_main");

		let this_csn		 =  t._scene;
		let this_cam		 =  t._camera;
		let this_rend		=  t._renderer;
//		this_canvas	  =  t._canvas;
		let this_canvas_base =  t._canvas_base;

//		let loader = new THREE.GLTFLoader();
		let loader = new GLTFLoader();
		loader.crossOrigin = 'anonymous';  // very important!

	loader.register((parser) => {
		return new VRMLoaderPlugin(parser);
	});




		loader.load(vrm_file_name,(gltf)=>{






//			VRM.from( gltf ).then( ( vrm ) => {
//			THREE.VRM.from( gltf ).then( ( vrm ) => {
			

				this_vrm = gltf.userData.vrm;
				this_csn.add( this_vrm.scene );

				this_vrm.scene.scale.x   =   vrm_scale
				this_vrm.scene.scale.y   =   vrm_scale;
				this_vrm.scene.scale.z   =   vrm_scale;

				
				t._vrm_array[vrm_file_name] = this_vrm;
				t._vrm = this_vrm;




//
//下記，なんだかうまくいかない
// THREE.VRMSchemaも，BoneNodeも使えない？
/*
//				let bone;
//				bone = this_vrm.humanoid.getNormalizedBoneNode( 'hips' );
				this_vrm.humanoid.getNormalizedBoneNode( 'hips' ).position.x =10;
				this_vrm.humanoid.getNormalizedBoneNode( 'hips' ).position.y = -20;
				this_vrm.humanoid.getNormalizedBoneNode( 'hips' ).position.z =0;


//				bone.position.set(t._vrm_x,  t._vrm_y,  t._vrm_z);
				bone.rotation.set(0,   Math.PI,	0);


下記のgetRawBoneを使うやり方に変更．

*/


//			let my_hips = this_vrm.humanoid.getRawBoneNode( 'hips' );
//			my_hips.position.set(0, -0.6, 0);
//			my_hips.rotation.set(0,   Math.PI,	0);

				this_vrm.scene.position.x = 0;
				this_vrm.scene.position.y = -0.85;
				this_vrm.scene.position.z = 0;

				this_vrm.scene.rotation.y = Math.PI;


				this_rend.render(this_csn, this_cam);


				t._vrm = gltf.userData.vrm;// 最後


		t._text_display( t._getText('reading_after') );
		setTimeout(function(){
			t._text_display( "" );


		}, 5000);





//			});
			}, ( progress ) => {
				console.log("loaded:"+progress.loaded+ " total:"+  progress.total);
				let percent = ( progress.loaded / progress.total )*100;
				console.log("****Loading model...,"+percent+"%" );
				t._text_display( t._getText('reading_before')+Math.round( percent, 2 ) + '%');
			}, ( error ) => alert( error )
		);

}


/*
	button function
*/



img_button_click(){
	if(this._stage == null  || this._stage == 2 ){ return; }

	console.log("img_button_click");
	document.getElementById('read_file5').click();
}

bvh_button_click(){
	if(this._stage == null  || this._stage == 2 ){ return; }
	console.log("bvh_button_click");
	document.getElementById('read_file8').click();
}

vrma_button_click(){
	if(this._stage == null  || this._stage == 2 ){ return; }
	console.log("vrma_button_click");
	document.getElementById('read_file9').click();
}


fbx_button_click(){
	if(this._stage == null  || this._stage == 2 ){ return; }
	console.log("fbx_button_click");
	document.getElementById('read_file10').click();
}


fbxmix_button_click(){
	if(this._stage == null  || this._stage == 2 ){ return; }
	console.log("fbxmix_button_click");
	document.getElementById('read_file11').click();
}


sound_button_click(){
	if(this._stage == null  || this._stage == 2 ){ return; }
	console.log("sound_button_click");
	document.getElementById('read_file6').click();
}

vrm_button_click(){
	if(this._stage == null  || this._stage == 2 ){ return; }
	console.log("vrm_button_click");
	document.getElementById('read_file7').click();
}


vrm_upload_ready(t){

	if(document.getElementById('span7') !=null){return;}

	let div_tmp        = document.createElement('div');
	div_tmp.innerHTML  += "<span id='span7'><input id='read_file7' type='file' style='display: none;'   /></span>";

////	let standard_window  =  document.getElementsByClassName("stage-header_stage-menu-wrapper_28MSs box_box_tWy-0")[0];
 
 	let standard_window  =  document.getElementsByClassName("stage_stage-bottom-wrapper_vRJed")[0];
 	
	standard_window.appendChild(div_tmp);

	let this_base = t._canvas_base;

	let my_this = t;

	let my_d = t._my_document;

	document.getElementById('read_file7').addEventListener('change', ev => {

			let input = my_d.getElementById('read_file7');
			let input2 = input.files[0];

			read_vrm_file_api(my_this, input2);
	}, true)


	function read_vrm_file_api(t,input){

		let reader = new FileReader();
	
		reader.addEventListener('load', function() {

			let vrm_file_content = reader.result;
			t.vrm_main(t, vrm_file_content,   0.8  );

		}, true)
		reader.readAsDataURL(input);

	}


}









vrm_play_button_click(args){



	
	
	if(this._stage == null  || this._stage == 2 ){  return; }


if(this.play_button_enabled ==1){return;}

	let gap1 = args.GAP1;
	let gap2 = args.GAP2;

console.log("gap1,gap2=",gap1,gap2);


	let my_t = this;

	let this_csn		=  this._scene;
	let this_cam		=  this._camera;
	let this_rend		=  this._renderer;


	if(this._sound_file_data!=null){
		setTimeout( function(){
			my_t._sound_file_data.play();
		}, gap1*1000 );
	}





	if(  this._bvh_array   ==  null){


		console.log("bvh is null, it does not work:", this._vmd);
		return;
	}





//	let my_t = this;





	setTimeout( function(){



		try{




			my_t.execute_bvh_loop(my_t._bvh_array[0],
							my_t._bvh_array[1],
							my_t._bvh_array[2],
							my_t._bvh_array[3],
							my_t._bvh_array[4],
							my_t._bvh_array[5],
							my_t._bvh_array[6],
							my_t._bvh_array[7]
						 );
		}catch(e){
			alert(e);
		}

	}, gap2*1000 );



}



stop_button_click(){
	console.log("stop_button_click");
	if(this._stage == null  || this._stage == 2 ){ return; }


	this.stop_bvh(this,"tmp");

	if(this._sound_file_data!=null){
		this._sound_file_data.pause();
		this._sound_file_data.currentTime = 0;

	}

	this._render_flg = 0;
	this.play_button_enabled = 0;
}




sound_url_read(arg){
	this._sound_file_data = new Audio();
	this._sound_file_data.src= arg.WORDS;
	this._sound_file_name= arg.WORDS;
	let my_t = this;
	this._text_display(""+ arg.WORDS +" loaded");
		setTimeout(function (){
			my_t._text_display("");
	},2500);

}

img_url_read(arg){
	this.img_url_read_file(arg.WORDS, this);
}

img_url_read_file(filename, t){
	this._img_file_name = filename;
	this.read_image_file_api(this,  filename,    0,  0.4, -0.3,                0,  4, 4);
}

img_ready(t){

	if(document.getElementById('span5') !=null){return;}

	let div_tmp        = document.createElement('div');
	div_tmp.innerHTML  += "<span id='span5'><input id='read_file5' type='file' style='display: none;' /></span>";

////	let standard_window  =  document.getElementsByClassName("stage-header_stage-menu-wrapper_28MSs box_box_tWy-0")[0];

 	let standard_window  =  document.getElementsByClassName("stage_stage-bottom-wrapper_vRJed")[0];
	standard_window.appendChild(div_tmp);

	let my_d    = t._my_document;
	let my_this = t;

	document.getElementById('read_file5').addEventListener('change', function(){
			let input = my_d.getElementById('read_file5');
			let input2 = input.files[0];
			img_file_read(my_this,input2);
	}, true)

	function img_file_read(t, input){

		let reader = new FileReader();


		t._text_display("Please wait...."+ input.name +".....");


		reader.addEventListener('load', function() {

			t._img_file_name = input.name;
			let data = reader.result;
			t.read_image_file_api(t,  data,  0,  0.4, -0.3,                0,  4, 4);
		}, true)

		reader.readAsDataURL(input);

	}

}


bvh_ready(t){

	if(document.getElementById('span8') !=null){return;}

	let div_tmp        = document.createElement('div');
	div_tmp.innerHTML  += "<span id='span8'><input id='read_file8' type='file' style='display: none;' /></span>";


////	let standard_window  =  document.getElementsByClassName("stage-header_stage-menu-wrapper_28MSs box_box_tWy-0")[0];

 	let standard_window  =  document.getElementsByClassName("stage_stage-bottom-wrapper_vRJed")[0];
 	
	standard_window.appendChild(div_tmp);

	let my_d    = t._my_document;
	let my_this = t;

	document.getElementById('read_file8').addEventListener('change', function(){
			let input = my_d.getElementById('read_file8');
			let input2 = input.files[0];

			bvh_file_read(my_this,input2);
	}, true)



	function bvh_file_read(t, input){

		t._bvh_file_name = input.name; 

		let reader = new FileReader();

		reader.addEventListener('load', function() {
			let text = reader.result;
			//my_d.load_bvh_option(nickname, input_file_name, loop_flg, pose_assign_num, wait_time, bx, by, bz,hip_position_flag, hip_rotation_flag, head_flag,  bvh_scale )
			t.load_bvh_option( "tmp",  text ,0,0,10, 0 ,-0.88 ,0,     0, 0,0,   0.004  );
		}, true)

		reader.readAsText(input);

	}

}









vrma_ready(t){

	if(document.getElementById('span9') !=null){return;}

	let div_tmp        = document.createElement('div');
	div_tmp.innerHTML  += "<span id='span9'><input id='read_file9' type='file' style='display: none;' /></span>";


////	let standard_window  =  document.getElementsByClassName("stage-header_stage-menu-wrapper_28MSs box_box_tWy-0")[0];

 	let standard_window  =  document.getElementsByClassName("stage_stage-bottom-wrapper_vRJed")[0];
 	
	standard_window.appendChild(div_tmp);

	let my_d    = t._my_document;
	let my_this = t;

	document.getElementById('read_file9').addEventListener('change', function(){
			let input = my_d.getElementById('read_file9');
			let input2 = input.files[0];

			vrma_file_read(my_this,input2);
	}, true)



	function vrma_file_read(t, input){

		t._vrma_file_name = input.name; 
///t.load_vrma2(input.name);

		let reader = new FileReader();
		reader.addEventListener('load', function() {
			let text = reader.result;
			t.load_vrma(text);
			
		}, true)

		reader.readAsDataURL(input);

	}


}





fbx_ready(t){

	if(document.getElementById('span10') !=null){return;}

	let div_tmp        = document.createElement('div');
	div_tmp.innerHTML  += "<span id='span10'><input id='read_file10' type='file' style='display: none;' /></span>";


////	let standard_window  =  document.getElementsByClassName("stage-header_stage-menu-wrapper_28MSs box_box_tWy-0")[0];

 	let standard_window  =  document.getElementsByClassName("stage_stage-bottom-wrapper_vRJed")[0];
 	
	standard_window.appendChild(div_tmp);

	let my_d    = t._my_document;
	let my_this = t;

	document.getElementById('read_file10').addEventListener('change', function(){
			let input = my_d.getElementById('read_file10');

			const blob = new Blob( [ input.files[0]  ], { type: 'application/octet-stream' } );
			let blob_filename  = URL.createObjectURL( blob );

			my_this.load_fbx(blob_filename, input.files[0].name , t);

	}, true)
}



fbx_all_remove(){

	let my_t = this;

	let this_csn		=  my_t._scene;
	let this_cam		=  my_t._camera;
	let this_rend		=  my_t._renderer;

	for (const key in my_t._fbx_object_array) {
		if(my_t._fbx_object_array.hasOwnProperty(key)){
			let tmp_scene = my_t._fbx_object_array[key];
			this_csn.remove(tmp_scene);
			delete my_t._fbx_object_array[key];
		}
	}

	this_rend.render(this_csn, this_cam);

}



load_fbx(blob_filename, filename, t) {


console.log("blob_filename",blob_filename,filename);

	let my_t = t;

	my_t._clock = new THREE.Clock();
	my_t._clock.start();


	//objectが既にaddされたものだったらremoveする
	if (filename in my_t._fbx_object_array) {
		let tmp_scene = my_t._fbx_object_array[filename];
		let this_csn  = my_t._scene;
		this_csn.remove(tmp_scene);
		delete my_t._fbx_object_array[filename];
	}


	let loader = new FBXLoader();

	loader.load(blob_filename, function(object){


		my_t._fbx_object_array[filename] = object;

console.log("fbx object", object);




		const motionHipsHeight = object.getObjectByName( 'Hips' ).position.y;

		let vrmHipsHeight = 0.85;
		if(my_t._vrm!=null){
			vrmHipsHeight = my_t._vrm.humanoid.normalizedRestPose.hips.position[ 1 ];
			console.log("vrmHipsHeight",vrmHipsHeight);
		}else{
			vrmHipsHeight = 0.85;
		}
		
		const hipsPositionScale = vrmHipsHeight / motionHipsHeight;



	let this_csn		=  my_t._scene;
	let this_cam		=  my_t._camera;
	let this_rend		=  my_t._renderer;

	this_rend.render(this_csn, this_cam);



object.position.x =   0;
object.position.y =  -0.8;
object.position.z =  0;



console.log("scale",hipsPositionScale );

		object.scale.set(hipsPositionScale,hipsPositionScale,hipsPositionScale)


		let mixer = new THREE.AnimationMixer(object);

		const action = mixer.clipAction(object.animations[0]);


		action.setLoop(THREE.LoopOnce); // 1回だけ再生
		action.clampWhenFinished = true; //最後にポーズで終わる


		my_t._fbx_animation_flg = true;

		mixer.addEventListener('finished', function(e) {
			console.log("mixer fbx finished");
			my_t._fbx_animation_flg = false;
		} );

		my_t.fbx_animate(my_t, mixer);

		action.play();

		//オブジェクトとすべての子孫に対してコールバック?
		object.traverse((child)=>{
			if(child.isMesh){
				child.castShadow = true;
				child.receiveShadow = true;
			}
		});


//		let this_csn  =  t._scene;
		this_csn.add( object );


	},
	(xhr) => {
		console.log((xhr.loaded / xhr.total) * 100 + '% loaded')
	},
	(error) => {
		console.log(error)
	});
}


fbx_animate(t,mixer) {

	let my_t = t;


	if(my_t._fbx_animation_flg == false){return;}


	let deltaTime = my_t._clock.getDelta()

console.log("fbx_animate4",deltaTime);

	if(mixer){
		mixer.update(deltaTime);
	}

	if ( my_t._vrm ) {
		my_t._vrm.update( deltaTime );
	}

	let this_csn		=  this._scene;
	let this_cam		=  this._camera;
	let this_rend		=  this._renderer;

	this_rend.render(this_csn, this_cam);

	requestAnimationFrame(tmp);


	function tmp(){
		my_t.fbx_animate(my_t, mixer);
	}
}



fbxmix_ready(t){

	if(document.getElementById('span11') !=null){return;}

	let div_tmp        = document.createElement('div');
	div_tmp.innerHTML  += "<span id='span11'><input id='read_file11' type='file' style='display: none;' /></span>";


////	let standard_window  =  document.getElementsByClassName("stage-header_stage-menu-wrapper_28MSs box_box_tWy-0")[0];

 	let standard_window  =  document.getElementsByClassName("stage_stage-bottom-wrapper_vRJed")[0];
 	
	standard_window.appendChild(div_tmp);

	let my_d    = t._my_document;
	let my_this = t;

	document.getElementById('read_file11').addEventListener('change', function(){
			let input = my_d.getElementById('read_file11');
			let input2 = input.files[0];

	const blob = new Blob( [ input.files[0]  ], { type: 'application/octet-stream' } );
	const content = URL.createObjectURL( blob );
	console.log("blob",input.files[0], blob);
	console.log("content",content);

		my_this._fbx_content = content;

//			my_this.load_fbxmix(content,  my_this);

	}, true)

}


load_fbxmix(context,t) {

console.log("load_fbxmix1", context);


	let my_t = t;

		my_t._clock = new THREE.Clock();
		my_t._clock.start();


	let currentVrm = t._vrm;


	let mixer = new THREE.AnimationMixer( currentVrm.scene  );
	mixer.timeScale = 1

	if ( mixer ) {

console.log("load_fbxmix3",context);

		let my_t = t;
		my_t.loadMixamoAnimation( context, currentVrm,my_t ); // ここでなにか起きている
		// ここがawaitになっていることが原因objectじゃなくて，Promiseを返してしまっている

		setTimeout(function (){

console.log("_ret",my_t._ret);

			let clip =  my_t._ret;

			console.log("mixer?",mixer);
			console.log("clip",clip);
			console.log("+++clip.tracks.length", clip.tracks.length);  //ここでエラー

			const newAction = mixer.clipAction( clip );

			newAction.setLoop(THREE.LoopOnce); // 1回だけ再生
			newAction.clampWhenFinished = true; //最後にポーズで終わる

			my_t._fbx_animation_flg = true;
		mixer.addEventListener('finished', function(e) {
			console.log("mixer fbx finished");
			my_t._fbx_animation_flg = false;
		} );

			newAction.reset().play();
			my_t.fbx_animate(my_t, mixer);

		},2000);

	}



}





sound_ready(t){

	if(document.getElementById('span6') !=null){return;}

	let div_tmp        = document.createElement('div');
	div_tmp.innerHTML  += "<span id='span6'><input id='read_file6' type='file' style='display: none;' /></span>";


////	let standard_window  =  document.getElementsByClassName("stage-header_stage-menu-wrapper_28MSs box_box_tWy-0")[0];

 	let standard_window  =  document.getElementsByClassName("stage_stage-bottom-wrapper_vRJed")[0];
 	
	standard_window.appendChild(div_tmp);

	let my_d = t._my_document;
	let my_this = t;

	document.getElementById('read_file6').addEventListener('change', function(){
			let input = my_d.getElementById('read_file6');
			sound_file_read(my_this,  URL.createObjectURL(input.files[0]) );  // blob

			my_this._sound_file_name=input.files[0].name;
			my_this._text_display(""+ input.files[0].name +" loaded");
			setTimeout(function (){
				my_this._text_display("");
			},2500);

	}, true)

	function sound_file_read(t, input){
		console.log(input);
		t._sound_file_data = new Audio();
		t._sound_file_data.src= input;
	}

}








read_image_file_api(t, filename, x, y, z, flg, w, h){




	// flg 0  use filename
	// flg 1  select file ?upload file?

	let this_csn		=  t._scene;
	let this_cam		=  t._camera;
	let this_rend		=  t._renderer;

	let this_canvas = t._canvas;



//if(flg==0){
//	console.log(filename);
//}

		const callbackPainting = function () {

			const geometry = new THREE.PlaneGeometry( w, h );
			const mesh     = new THREE.Mesh(geometry, materialPainting);

// THREE.PlaneGeometry ( width, height , widthSegments, heightSegments )

			mesh.position.x =  x;
			mesh.position.y =  y;
			mesh.position.z =  z;

	//		mesh.rotation.y =  Math.PI;

console.log(x,y,z,w,h);


			this_csn.add(mesh);
		};

		let texturePainting;

		if(flg == 0){
			texturePainting   =  new THREE.TextureLoader().load( filename, callbackPainting );
		}else{
			texturePainting   = new THREE.TextureLoader().load(URL.createObjectURL(filename), callbackPainting);
		}

		const materialPainting  =  new THREE.MeshBasicMaterial( {  map: texturePainting } );


		t._text_display(""+ filename +" loaded");
		setTimeout(function (){
			t._text_display("");
		},2500);


		rend_tmp();
		function rend_tmp(){
			this_rend.render(this_csn, this_cam);
		}

		setTimeout(rend_tmp,1000 ) ;
		setTimeout(rend_tmp,5000 );

}




move_vrm(args){
	if(this._stage == null  || this._stage == 2 ){ return; }

/*
	let bone = THREE.VRMSchema.HumanoidBoneName.Hips;
	let pos_x = this._vrm.humanoid.getBoneNode(bone).position.x + args.POS_X/100;
	let pos_y = this._vrm.humanoid.getBoneNode(bone).position.y + args.POS_Y/100;
	let pos_z = this._vrm.humanoid.getBoneNode(bone).position.z + args.POS_Z/100;


	this._vrm.humanoid.getBoneNode(bone).position.set(pos_x, pos_y, pos_z );

*/

///	let my_hips = this._vrm.humanoid.getRawBoneNode( 'hips' );

	
	this._vrm.scene.position.x += args.POS_X/100;
	this._vrm.scene.position.y += args.POS_Y/100;
	this._vrm.scene.position.z += args.POS_Z/100;

	let this_csn		=  this._scene;
	let this_cam		=  this._camera;
	let this_rend		=  this._renderer;

	this_rend.render(this_csn, this_cam);

	//redraw
	setTimeout(function(){
		this_rend.render(this_csn, this_cam);
	},1000);


}

rotate_vrm(args){
	if(this._stage == null  || this._stage == 2 ){ return; }

/*
	let bone = THREE.VRMSchema.HumanoidBoneName.Hips;
	let rot_x = this._vrm.humanoid.getBoneNode(bone).rotation.x + args.ROT_X * Math.PI / 180 ;
	let rot_y = this._vrm.humanoid.getBoneNode(bone).rotation.y + args.ROT_Y * Math.PI / 180 ;
	let rot_z = this._vrm.humanoid.getBoneNode(bone).rotation.z + args.ROT_Z * Math.PI / 180 ;
console.log(rot_x, rot_y, rot_z );
	this._vrm.humanoid.getBoneNode(bone).rotation.set(rot_x, rot_y, rot_z );
*/

//	let my_hips = this._vrm.humanoid.getRawBoneNode( 'hips' );

	this._vrm.scene.rotation.x += args.ROT_X * Math.PI / 180 ;
	this._vrm.scene.rotation.y += args.ROT_Y * Math.PI / 180 ;
	this._vrm.scene.rotation.z += args.ROT_Z * Math.PI / 180 ;


	let this_csn		=  this._scene;
	let this_cam		=  this._camera;
	let this_rend		=  this._renderer;

	this_rend.render(this_csn, this_cam);

	//redraw
	setTimeout(function(){
		this_rend.render(this_csn, this_cam);
	},1000);

}

arm_set(args){
	console.log("arm set");
	if(this._stage == null  || this._stage == 2 ){ return; }

	let this_vrm	= this._vrm;

	let this_csn	=  this._scene;
	let this_cam	=  this._camera;
	let this_rend	=  this._renderer;

console.log("this_vrm",this_vrm);
	if(this_vrm != null ){
	

//		this_vrm.humanoid.getBoneNode(THREE.VRMSchema.HumanoidBoneName.LeftUpperArm).rotation.z   =   Math.PI /180 * args.LEFT_A;
//		this_vrm.humanoid.getBoneNode(THREE.VRMSchema.HumanoidBoneName.RightUpperArm).rotation.z  =   Math.PI /180 * args.RIGHT_A;


		this_vrm.humanoid.getRawBoneNode( 'leftUpperArm' ).rotation.z   =   Math.PI /180 * args.LEFT_A;
		this_vrm.humanoid.getRawBoneNode( 'rightUpperArm' ).rotation.z  =   Math.PI /180 * args.RIGHT_A;


		this_rend.render(this_csn, this_cam);
	}

}


pose_set(args){
	console.log("pose set");
	if(this._stage == null  || this._stage == 2 ){ return; }

	let this_vrm	= this._vrm;

	let this_csn	=  this._scene;
	let this_cam	=  this._camera;
	let this_rend	=  this._renderer;

	if(this_vrm != null ){

//		let bone = THREE.VRMSchema.HumanoidBoneName;
//		let keyArray = Object.keys(bone);

		this.bone_names.forEach(key => {
			if(this._vrm.humanoid.getRawBoneNode(key) !=null){
				this._vrm.humanoid.getRawBoneNode(key).rotation.set(0,0,0);
			}
		})

//		bone = THREE.VRMSchema.HumanoidBoneName.Hips;


//// 下記はうまくいかない
//		this._vrm.humanoid.getRawBoneNode('hips').rotation.set(0,   Math.PI, 0);

//シーンをrotationする
		this._vrm.scene.rotation.y = Math.PI;



		this_rend.render(this_csn, this_cam);

		//redraw
		setTimeout(function(){
			this_rend.render(this_csn, this_cam);
		},1000);

	}

}




parts(args){

let number = args.PARTS;

let rx = args.ROT_X* Math.PI / 180 ;;
let ry = args.ROT_Y* Math.PI / 180 ;;
let rz = args.ROT_Z* Math.PI / 180 ;;

if(this._vrm == null ) { return; }


let tmp_vrm = this._vrm;


	this._vrm.humanoid.getRawBoneNode(this.bone_names[number-1]).rotation.set(rx,ry,rz);


/*
if( number==1) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.Hips).rotation.set(rx,ry,rz);
if( number==2) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.Spine).rotation.set(rx,ry,rz);
if( number==3) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.Chest).rotation.set(rx,ry,rz);
if( number==4) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.UpperChest).rotation.set(rx,ry,rz);

if( number==5) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.Neck).rotation.set(rx,ry,rz);
if( number==6) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.Head).rotation.set(rx,ry,rz);
if( number==7) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.LeftShoulder).rotation.set(rx,ry,rz);
if( number==8) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.LeftUpperArm).rotation.set(rx,ry,rz);
if( number==9) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.LeftLowerArm).rotation.set(rx,ry,rz);
if( number==10) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.LeftHand).rotation.set(rx,ry,rz);

if( number==11) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.LeftUpperLeg).rotation.set(rx,ry,rz);
if( number==12) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.LeftLowerLeg).rotation.set(rx,ry,rz);
if( number==13) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.LeftFoot).rotation.set(rx,ry,rz);
if( number==14) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.LeftToes).rotation.set(rx,ry,rz);
if( number==15) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.LeftThumbDistal).rotation.set(rx,ry,rz);
if( number==16) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.LeftThumbIntermediate).rotation.set(rx,ry,rz);
if( number==17) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.LeftThumbProximal).rotation.set(rx,ry,rz);
if( number==18) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.LeftIndexDistal).rotation.set(rx,ry,rz);
if( number==19) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.LeftIndexIntermediate).rotation.set(rx,ry,rz);
if( number==20) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.LeftIndexProximal).rotation.set(rx,ry,rz);

if( number==21) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.LeftMiddleDistal).rotation.set(rx,ry,rz);
if( number==22) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.LeftMiddleIntermediate).rotation.set(rx,ry,rz);
if( number==23) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.LeftMiddleProximal).rotation.set(rx,ry,rz);
if( number==24) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.LeftRingDistal).rotation.set(rx,ry,rz);
if( number==25) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.LeftRingIntermediate).rotation.set(rx,ry,rz);
if( number==26) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.LeftRingProximal).rotation.set(rx,ry,rz);
if( number==27) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.LeftLittleDistal).rotation.set(rx,ry,rz);
if( number==28) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.LeftLittleIntermediate).rotation.set(rx,ry,rz);
if( number==29) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.LeftLittleProximal).rotation.set(rx,ry,rz);
if( number==30) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.LeftEye).rotation.set(rx,ry,rz);

if( number==31) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.RightShoulder).rotation.set(rx,ry,rz);
if( number==32) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.RightUpperArm).rotation.set(rx,ry,rz);
if( number==33) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.RightLowerArm).rotation.set(rx,ry,rz);
if( number==34) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.RightHand).rotation.set(rx,ry,rz);
if( number==35) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.RightUpperLeg).rotation.set(rx,ry,rz);
if( number==36) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.RightLowerLeg).rotation.set(rx,ry,rz);
if( number==37) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.RightFoot).rotation.set(rx,ry,rz);
if( number==38) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.RightToes).rotation.set(rx,ry,rz);
if( number==39) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.RightThumbDistal).rotation.set(rx,ry,rz);
if( number==40) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.RightThumbIntermediate).rotation.set(rx,ry,rz);

if( number==41) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.RightThumbProximal).rotation.set(rx,ry,rz);
if( number==42) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.RightIndexDistal).rotation.set(rx,ry,rz);
if( number==43) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.RightIndexIntermediate).rotation.set(rx,ry,rz);
if( number==44) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.RightIndexProximal).rotation.set(rx,ry,rz);
if( number==45) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.RightMiddleDistal).rotation.set(rx,ry,rz);
if( number==46) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.RightMiddleIntermediate).rotation.set(rx,ry,rz);
if( number==47) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.RightMiddleProximal).rotation.set(rx,ry,rz);
if( number==48) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.RightRingDistal).rotation.set(rx,ry,rz);
if( number==49) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.RightRingIntermediate).rotation.set(rx,ry,rz);
if( number==50) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.RightRingProximal).rotation.set(rx,ry,rz);
if( number==51) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.RightLittleDistal).rotation.set(rx,ry,rz);
if( number==52) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.RightLittleIntermediate).rotation.set(rx,ry,rz);
if( number==53) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.RightLittleProximal).rotation.set(rx,ry,rz);
if( number==54) tmp_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.RightEye).rotation.set(rx,ry,rz);
*/

	let this_csn		=  this._scene;
	let this_cam		=  this._camera;
	let this_rend		=  this._renderer;


	this_rend.render(this_csn, this_cam);

	//redraw
	setTimeout(function(){
		this_rend.render(this_csn, this_cam);
	},1000);




}






display_text2d(args){
	let this_csn		=  this._scene;
	let this_cam		=  this._camera;
	let this_rend		=  this._renderer;

	let this_canvas = this._canvas;

	let this_text = args.WORDS
	let this_x    = args.POS_X;
	let this_y    = args.POS_Y;
//	let this_z    = args.POS_Z;



	let div_tmp        = document.createElement('div');
	div_tmp.style      = "position:absolute; top:"+this_y+"px ; left:"+this_x+"px";
	div_tmp.innerHTML  = this_text;

if(this._popup_window_flag==1){
	this._canvas_base.appendChild(div_tmp);

}else{
////	let standard_window  =  document.getElementsByClassName("stage_stage-bottom-wrapper_fnczd")[0];

 	let standard_window  =  document.getElementsByClassName("stage_stage-bottom-wrapper_vRJed")[0];

	standard_window.appendChild(div_tmp);
}




}



display_text(args){

	let this_csn		=  this._scene;
	let this_cam		=  this._camera;
	let this_rend		=  this._renderer;

	let this_canvas = this._canvas;

	let this_text = args.WORDS
	let this_x    = args.POS_X;
	let this_y    = args.POS_Y;
	let this_z    = args.POS_Z;

	function set_texture() {

		let canvas = document.createElement('canvas');
		canvas.width   = 200;
		canvas.height  = 15;

		let style_str  = "position:absolute; top:0px; left: 0px;background-color:#ffffff;";


		canvas.style  = style_str;

	let	textContext = canvas.getContext('2d');
		textContext.font = "12px 'ＭＳ Ｐゴシック'";
		textContext.textBaseline = "top";
//		textContext.fillStyle = 'rgb( 255, 255, 255)';
		textContext.fillStyle = 'rgba(0, 0, 0,       0)'; // 'rgbA!'(alpha)  not rgb
		textContext.fillRect(0, 0, canvas.width, canvas.height);

		textContext.fillStyle = "rgb(10, 40, 50)";
		textContext.fillText(this_text, 0, 0);
		let texture = new THREE.CanvasTexture(canvas);
		return texture;
	}


	let geometry = new THREE.PlaneGeometry(2, 0.15);
	let material = new THREE.MeshBasicMaterial({
		color: 0xeeeeee,
		map: set_texture(),
		transparent: true,
		alpha: true,
		opacity:1
	});


	let planeMesh = new THREE.Mesh(geometry, material);

	planeMesh.position.x =  this_x;
	planeMesh.position.y =  this_y;
	planeMesh.position.z =  this_z;

	//planeMesh.material.map.needsUpdate = true;


	this_csn.add(planeMesh);
	this_rend.render(this_csn, this_cam);





}





_get_color_code(selected_number){

	let color_code;

	if(selected_number == 1){
		color_code = "#ffffff";

	}else if(selected_number == 2){
		color_code = "#000000";

	}else if(selected_number == 3){
		color_code = "#ff0000";
	}else if(selected_number == 4){
		color_code = "#00ff00";
	}else if(selected_number == 5){
		color_code = "#0000ff";

	}else if(selected_number == 6){ // yellow
		color_code = "#ffff00";
	}else if(selected_number == 7){ // magenta
		color_code = "#ff00ff";
	}else if(selected_number == 8){ // cyan
		color_code = "#00ffff";

	}else if(selected_number == 9){
		color_code = "#ffaaaa";
	}else if(selected_number == 10){
		color_code = "#aaffaa";
	}else if(selected_number == 11){
		color_code = "#aaaaff";

	}else if(selected_number == 12){
		color_code = "#ffffaa";
	}else if(selected_number == 13){
		color_code = "#ffaaff";
	}else if(selected_number == 14){
		color_code = "#aaffff";
	}

	return color_code;

}

load_js_files(load_script_filename, callback, t, this_pos_x, this_pos_y, this_width, this_height, this_bgcolor ){

	if(load_script_filename.length==0){
		callback(t, this_pos_x, this_pos_y, this_width, this_height, this_bgcolor );
	}


	let elems = new Array();
	load_script_filename.forEach(function(element,i) {
		elems[i] = element+"?"+(new Date()).getTime();	   // cache
	});
	let count = 0;
	let script = new Array();
	elems.forEach(function(element,i) {
		script[i] = document.createElement('script');
		script[i].src = element;
		document.body.appendChild(script[i]);

		script[i].onload = function() {
			console.log("script loaded", elems[count]);
			t._text_display("script loaded Total "+ Math.round( count/elems.length*100, 2 ) +"% "+elems[count] );
			count++;	
			if(count == elems.length) {
				//break;
				callback(t, this_pos_x, this_pos_y, this_width, this_height, this_bgcolor );
			}
		};
	});
}


_text_display(my_message){

	let div_tmp;

	div_tmp = document.getElementById("div_message");

	if(div_tmp==null){
		div_tmp        = document.createElement('div');
		div_tmp.style      = "position:absolute; top:100px ; left:10px";
	}

	div_tmp.innerHTML  = my_message;
	div_tmp.id = "div_message";
	
	
//		let standard_window  =  document.getElementsByClassName("stage-header_stage-menu-wrapper_28MSs box_box_tWy-0")[0];


///// 	let standard_window  =  document.getElementsByClassName("stage_stage-bottom-wrapper_fnczd")[0];
 	let standard_window  =  document.getElementsByClassName("stage_stage-bottom-wrapper_vRJed")[0];



console.log("standard_window");
console.log(standard_window);


		standard_window.appendChild(div_tmp);

}


make_window(args){
	this.make_window_process(this._get_color_code(args.BG_SELECT_COLOR));
}

make_window2(args){
	this.make_window_process(args.BG_COLOR);
}

make_window_process(this_bgcolor){


	if( this._stage == 2 ){ return; }

console.log("make_window_process1");

	this._parameter_init(this);

	this._mouse_controls  =  null;

	this._popup_window_flag   =  0;

	this.play_button_enabled  =  0;

	this._window = window;

	let width   = 408, height  = 306;

	this._stage = 2;  // reset





////	let standard_window  =  document.getElementsByClassName("stage_stage-bottom-wrapper_fnczd")[0];

 	let standard_window  =  document.getElementsByClassName("stage_stage-bottom-wrapper_vRJed")[0];


//	let tmp_window  =  document.getElementsByClassName("stage_stage-wrapper_35Uar box_box_tWy-0")[0];
// tmp_window.innerHTML ="";





	let tmp_canvas  =  document.getElementsByTagName("canvas")[0];
    tmp_canvas.id = "tmp1";

	tmp_canvas=null;


console.log("t1",tmp_canvas);


	// find my_canvas
	let old_my_canvas = document.getElementById("my_canvas");

	// remove old my_canvas
	if(old_my_canvas != null){
		this._stage = null;
		standard_window.removeChild(old_my_canvas);
	}

	let canvas     =  document.createElement('canvas');
	let style_str  =  "position:absolute; top:0px; left:0px;background-color:#ffffff;";

	canvas.style  = style_str;
	canvas.width  = width;
	canvas.height = height;
	canvas.id	 = "my_canvas";

	standard_window.appendChild(canvas); 


	this._canvas = canvas;

console.log("make_window_process2");





	load_process1(this);


	function load_process1(t){

		let load_counter = 0;
		let load_script_filename = new Array();

		t.load_js_files(load_script_filename, load_process2,t);

	}


	function load_process2(t){

		let load_counter=0;
		let load_script_filename = new Array();

//		t.load_js_files(load_script_filename, load_process3,t);
		t.load_js_files(load_script_filename, load_process5,t);// jump for vrm

	}


	function load_process5(t){
	
		make_scene(t);
	}







	function make_scene(this_object){

console.log("make scene");

		let renderer = new WebGLRenderer({
			canvas: document.querySelector('#my_canvas'),
			transparent: true,
			alpha: true
		});




		renderer.setPixelRatio(window.devicePixelRatio);
		renderer.setClearColor(this_bgcolor);
		renderer.setSize(width, height);

////		let d = document.getElementsByClassName("stage_stage-bottom-wrapper_fnczd")[0];
	 	let d  =  document.getElementsByClassName("stage_stage-bottom-wrapper_vRJed")[0];

		renderer.setSize(parseInt(d.style.width),parseInt(d.style.height) );
// サイズに合わせて読み込み





	let fullscreen_button;

if(parseInt(d.style.width) > 480){
////	small_button = document.getElementsByClassName("stage-header_stage-button-icon_1SHv0")[0];
	let small_button = document.getElementsByClassName("stage-header_stage-button-icon_tUZn7")[0];

	small_button.addEventListener("click", small_set);
// [0]が標準サイズにする

}else{
////	fullscreen_button = document.getElementsByClassName("stage-header_stage-button-icon_1SHv0")[2];

	fullscreen_button = document.getElementsByClassName("stage-header_stage-button-icon_tUZn7")[2];
	fullscreen_button.addEventListener("click", full_set);
// [2]が全画面にする
}

//	if(typeof fullscreen_button === 'undefined'){





	function full_set(){
		setTimeout(full_set_t,1500); // time タイムラグが必要．イベントが多重に定義されているため？
	}
	// 時間と取らないと，サイズが正しく取得できない．

	function full_set_t(){

////		let d = document.getElementsByClassName("stage_stage-bottom-wrapper_fnczd")[0]; // [0]に注意

	let d = document.getElementsByClassName("stage_stage-bottom-wrapper_vRJed")[0]; // [0]に注意

		renderer.setSize(parseInt(d.style.width),parseInt(d.style.height) );
		renderer.render(scene, camera);
		
////		small_button = document.getElementsByClassName("stage-header_stage-button-icon_1SHv0")[0]; // [0]に注意

		small_button = document.getElementsByClassName("stage-header_stage-button-icon_tUZn7")[0]; // [0]に注意

		small_button.removeEventListener("click", small_set);
		small_button.addEventListener("click", small_set);



	}


	function small_set(){
		setTimeout(small_set_t,1500); // time タイムラグが必要．イベントが多重に定義されているため？ 
	}


	function small_set_t(){

////		let d = document.getElementsByClassName("stage_stage-bottom-wrapper_fnczd")[0]; // [0]に注意
		let d = document.getElementsByClassName("stage_stage-bottom-wrapper_vRJed")[0]; // [0]に注意

		renderer.setSize(parseInt(d.style.width),parseInt(d.style.height) );
		renderer.render(scene, camera);
		

////		fullscreen_button = document.getElementsByClassName("stage-header_stage-button-icon_1SHv0")[2]; // [2]に注意
		fullscreen_button = document.getElementsByClassName("stage-header_stage-button-icon_tUZn7")[2]; // [2]に注意

		fullscreen_button.removeEventListener("click", full_set);
		fullscreen_button.addEventListener("click", full_set);

	}


		let scene = new THREE.Scene();

		let camera = new THREE.PerspectiveCamera(45, width / height);
		camera.position.set(0, 0, 2);

		this_object._renderer = renderer;
		this_object._scene	= scene;
		this_object._camera   = camera;
		this_object._canvas_base = document.body;

		this_object._my_document = document;

		let light = new THREE.DirectionalLight( 0xffffff );
		light.position.set( 1.0, 1.0, 1.0 ).normalize();
		scene.add( light );

		let light2 = new THREE.DirectionalLight( 0xffffff );
		light2.position.set( 0, 1.0, 1.0 ).normalize();
		scene.add( light2 );

		let light3 = new THREE.DirectionalLight( 0xffffff );
		light3.position.set( 0, 0.5, 1.0 ).normalize();
		scene.add( light3 );


		renderer.render(scene, camera);



//		this_object.character_upload();


//		this_object.bvh_ready(this_object);



		this_object.sound_ready(this_object);

		this_object.img_ready(this_object);

		this_object.bvh_ready(this_object);

		this_object.vrma_ready(this_object);


		this_object.fbx_ready(this_object);
		this_object.fbxmix_ready(this_object);

		this_object.vrm_upload_ready(this_object);

		this_object._stage = "dummy";



		this_object._text_display( this_object._getText('ready_after'));
		setTimeout(function(){
			this_object._text_display("");
		}, 2500);

	}


}
// end of make windows process


popup_window(args){


	if( this._stage == 2 ){ return; }
	
	
	this._mouse_controls  =  null;

	this._parameter_init(this);

	this._popup_window_flag = 1;

	this.play_button_enabled =0;

	this._stage  =  2;

console.log(args.POS_X, args.POS_Y, args.WIDTH, args.HEIGHT, args.BGCOLOR);

	let this_pos_x   =  args.POS_X;
	let this_pos_y   =  args.POS_Y;
	let this_width   =  args.WIDTH;
	let this_height  =  args.HEIGHT;
	let this_bgcolor =  this._get_color_code(args.BGCOLOR)



		let opt = '';
		opt += 'scrollbars=1';
		opt += ',resizable=1';
		opt += ',toolbar=0';
		opt += ',directories=0';
		opt += ',menubar=0,';
		opt += ',left='+this_pos_x;
		opt += ', top='+this_pos_y;
		opt += ',width='+(parseInt(this_width)+20);
		opt += ',height='+(parseInt(this_height)+20);


		let newWin = window.open("about:blank","my_name"+(new Date()).getTime(), opt);
		// 名前の違うポップアップウィンドウを出して作っていくようにすることが
		// 解決が早いかもしれない

//		console.log("b0",  newWin.document);

	//	console.log("b2",  newWin.document.body);
		// bodyを作った時点で，canvasが自動的に付与される？らしく削除もできない？

		this._window   =  newWin;

		let div_tmp;
		let div_id;

		div_tmp = newWin.document.getElementById("div_message");

		if(div_tmp==null){
			div_tmp        = newWin.document.createElement('div');
			div_tmp.style      = "position:absolute; top:0px ; left:0px";
		}

		div_tmp.innerHTML  = this._getText('ready_before');
		div_tmp.id = "div_message";

		newWin.document.body.appendChild(div_tmp);
		
		// ブラウザ(Firefox)によっては，時間差が必要．タグの入れ替えに時間がかかっている？
		let my_t = this;
		setTimeout(function(){
			make_pop_window(my_t, this_pos_x, this_pos_y, this_width, this_height, this_bgcolor);
		},2000);


function make_pop_window(t, this_pos_x, this_pos_y, this_width, this_height, this_bgcolor ){

//	process1(t, this_pos_x, this_pos_y, this_width, this_height, this_bgcolor );
//いきなりprocess2でもOK?


	process2(t, this_pos_x, this_pos_y, this_width, this_height, this_bgcolor );



	function process1(t, this_pos_x, this_pos_y, this_width, this_height, this_bgcolor ){
		let load_script_filename =[
//			'https://unpkg.com/three@0.147.0/build/three.js',
/////			'https://m-asyua.github.io/scratch_contents/three.js',
		];
		t.load_js_files(load_script_filename, process2,t, this_pos_x, this_pos_y, this_width, this_height, this_bgcolor );
	}


// document root is
// 
// C:\Users\XXXXXX\sct_test\scratch-gui\build
//

	function process2(t, this_pos_x, this_pos_y, this_width, this_height, this_bgcolor ){
		let load_script_filename =[
//			'https://unpkg.com/@pixiv/three-vrm@0.6.11/lib/three-vrm.js',
//			'https://unpkg.com/three@0.147.0/examples/js/controls/OrbitControls.js',
//			'https://unpkg.com/three@0.147.0/examples/js/loaders/GLTFLoader.js'
//			'https://m-asyua.github.io/scratch_contents/three-vrm.js',
/////			'https://m-asyua.github.io/scratch_contents/OrbitControls.js'
//			'https://m-asyua.github.io/scratch_contents/GLTFLoader.js',
//			'https://m-asyua.github.io/scratch_contents/BVHLoader.js'

		];
		t.load_js_files(load_script_filename, process3,t, this_pos_x, this_pos_y, this_width, this_height, this_bgcolor );
	}


	function process3(t, this_pos_x, this_pos_y, this_width, this_height, this_bgcolor ){

		next2(t, this_pos_x, this_pos_y, this_width, this_height, this_bgcolor );
	}





	function next2(this_object, this_pos_x, this_pos_y, this_width, this_height, this_bgcolor ){




		let renderer = new THREE.WebGLRenderer({alpha: true, transparent: true});
		renderer.setPixelRatio(window.devicePixelRatio);
		renderer.setSize(this_width , this_height);
		renderer.setClearColor(this_bgcolor);

console.log("next2");

		newWin.document.body.appendChild( renderer.domElement ); // Point!!!!!


		let scene = new THREE.Scene();

		let camera    = new THREE.PerspectiveCamera(45, this_width / this_height);
		camera.position.set(0, 0, 2);

		this_object._renderer =  renderer;
		this_object._scene	  =  scene;
		this_object._camera   =  camera;
		this_object._canvas_base = newWin.document.body;

		this_object._my_document = newWin.document;


		let light = new THREE.DirectionalLight( 0xffffff );
		light.position.set( 1.0, 1.0, 1.0 ).normalize();
		scene.add( light );


		renderer.render(scene, camera);


//		this_object.character_upload();
//		this_object.bvh_ready(this_object);



		this_object.sound_ready(this_object);

		this_object.img_ready(this_object);

		this_object.bvh_ready(this_object);

		this_object.vrm_upload_ready(this_object);





		let div_id = newWin.document.getElementById("div_message");
		if(div_id!=null){
			div_id.innerHTML= this_object._getText('ready_after');
			setTimeout(function(){
				div_id.innerHTML="";
			}, 2000);
		}
		
		
		this_object._stage = "dummy";
		
		
	}

} // make popup window



} // popup window






load_bvh_option(nickname, input_text, loop_flg, pose_assign_num, wait_time, bx, by, bz,hip_position_flag, hip_rotation_flag, head_flag,  bvh_scale ){






	let wait_bvh_loop       =    500;      // loop, wait for restart BVH 

	let hip_position_scale  =  0.018;

//  228行目付近の
//baseX +=Math.tan(roty-Math.PI)* z;あたりの計算がおかしい気がするので
// 見直したほうがよい
/*


BVHファイルは，キャラクタの現在地を起点として，
BVHの補正値を足して，
さらにBVHのファイル内のHipポジションを使って
移動している．


*/





	
	
	this.load_bvh(this, nickname, input_text, loop_flg, pose_assign_num, wait_time, bx, by, bz, hip_position_flag, hip_rotation_flag, head_flag,  bvh_scale );

}

load_bvh(t,  nickname, input_text, loop_flg, pose_assign_num, wait_time, bx, by, bz, hip_position_flag, hip_rotation_flag, head_flag,  bvh_scale ){


//console.log("lllexeb" ,   hip_flag,   head_flag);
//	if( hip_flag == "undefined"  ||  hip_flag  == null ){ hip_flag  = 1;  }
//	if(head_flag == "undefined"  ||  head_flag == null ){ head_flag = 1;  }

	if( hip_position_flag == "undefined"  ||  hip_position_flag  == null ){ hip_position_flag  = 1;  }
	if( hip_rotation_flag == "undefined"  ||  hip_rotation_flag  == null ){ hip_rotation_flag  = 1;  }
	if(head_flag == "undefined"  ||  head_flag == null ){ head_flag = 1;  }


	this.character_loop_flag[nickname]    =  Number(loop_flg);

	assign_pattern_character(this, nickname, Number(pose_assign_num) );

	this.bvh_setTimeout_period[nickname]  = Number(wait_time);

	this.characters_bvh_position[nickname]     =  new Array();
	this.characters_bvh_position[nickname][0]  =  Number(bx);
	this.characters_bvh_position[nickname][1]  =  Number(by);
	this.characters_bvh_position[nickname][2]  =  Number(bz);


function assign_pattern_character(t, nickname, num){

	console.log(t.pose_assign,   nickname);

	t.pose_assign[nickname] = new Array();
	for(let i=0;i<t.bone_names.length;i++){ 
		t.pose_assign[nickname][i] = -1;
	}
	t.pose_assign[nickname] = copyArray(   t.pose_assign_array[num]);
}

function copyArray(a) {
	return Array.apply(null,a);
}







// ★ここのロードをしないようにする
//	execute_bvh_loop(t,nickname, input_text, 1, hip_position_flag, hip_rotation_flag, head_flag,  bvh_scale );


this._bvh_array   =    new Array(t,nickname, input_text, 1, hip_position_flag, hip_rotation_flag, head_flag,  bvh_scale);



		t._text_display(""+ this._bvh_file_name+" loaded");
		setTimeout(function (){
			t._text_display("");
		},5000);




		


/*
	// load BVH file
	fetch(input_file_name).then(function(response) {
		response.text().then(function(text) {
			execute_bvh_loop(t,nickname, text, 1, hip_position_flag, hip_rotation_flag, head_flag,  bvh_scale );
		});
	});
*/






} // function
/////////////////////////////////////////////////////



execute_bvh_loop(t,nickname, bvh_file_content, execute,  hip_position_flag, hip_rotation_flag, head_flag,  bvh_scale ){

	if(execute){
		t.execute_bvh(t,nickname, bvh_file_content, hip_position_flag, hip_rotation_flag, head_flag,  bvh_scale );
	}


//  ここ改良できるかも．コールバックを使うと効率良いかも

	if(this.character_loop_flag[nickname]){
		if(end_of_clips_array[nickname] == -1 ){
			end_of_clips_array[nickname] = 0;
			setTimeout(t.execute_bvh_loop, wait_bvh_loop, t,nickname, bvh_file_content,1, hip_position_flag, hip_rotation_flag, head_flag,  bvh_scale );
		}else{
			setTimeout(t.execute_bvh_loop, wait_bvh_loop, t,nickname, bvh_file_content,0, hip_position_flag, hip_rotation_flag, head_flag,  bvh_scale );
		}
	}
}



execute_bvh(t,nickname, bvh_file_content,    hip_position_flag, hip_rotation_flag, head_flag,  bvh_scale ){






	let characters_current_position  =  new Array();

	// if a new bvh is comming, clear timeout
	this.clear_timeout_bvh(t,nickname);

	let  bvh_loader  =  new BVHLoader();
	let  bvh_object  =  bvh_loader.parse(bvh_file_content);

	let  number_pos  =  bvh_object.clip.tracks[1].values.length / 4;  

	// count the number of clips
	this.number_of_clip_array[nickname] = number_pos;

//	this_vrm  =  character_scene_array[nickname];

//	pose_content    =  this_vrm.humanoid.getPose();


	let pose_content    =  t._vrm.humanoid.getPose();


	// for hips position
	let num_of_clip_pos = 0;
	for(let c = 0;  c < number_pos;   c++){
		setTimeout(hip_position_set, 
			c * t.bvh_setTimeout_period[nickname], 
			t,
			bvh_object, 
			num_of_clip_pos, 
			pose_content, 
			nickname,  
			hip_position_flag, 
			hip_rotation_flag, 
			head_flag,  
			bvh_scale);
		num_of_clip_pos += 3;
	}



	let num_of_clip   = 0;
	let this_final    = 0;
	t.timeout_array[nickname]= new Array();

	for(let c = 0;  c < number_pos;   c++){

		if(c+1 >= number_pos){
			this_final = -1; 
		}

		// if bvh ends, this_final=-1
		t.timeout_array[nickname][c]   =  setTimeout(body_pose_set,
			 c * t.bvh_setTimeout_period[nickname], 
			 t,
			 bvh_object, 
			 num_of_clip, 
			 pose_content, 
			 nickname, 
			 this_final, 
			     head_flag);
		num_of_clip += 4;
	}





//	setTimeout(position_return, (number_pos+1) * bvh_setTimeout_period[nickname], nickname);





//
// functions (BVH)
//




////////////////////////////////

function hip_position_set(t,bvh_object, num_of_clip_pos , pose_content, nickname, hip_position_flag, hip_rotation_flag, head_flag,  bvh_scale ){


// 0:キャラクタの現在の位置座標を中心にしてモーションを動かす　　デフォルト
// 開始位置はずれないが，終了位置はずれていく．
// 1:キャラクタの現在の位置座標を使わず，モーションを動かす（BVHデータに入っている中心のデータを使う）．
// 開始位置がずれる，終了位置もずれていく．


// 0:キャラクタの現在の体の向きをもとにモーションを動かす　　デフォルト
// ※BVHファイルにも方向の情報が入っているので，
// 体の向きに合わせて，変換しなおす
// 1:キャラクタの現在の体の向きは使わずに，モーションを動かす（BVHファイルに入っている向きのデータを使う）
// キャラクタの現在の体の向きは無視されて，BVHの中のファイルが使われる．

// 0:頭部のモーションはそのまま再現する　　デフォルト
// 1:頭部のモーションは無視する


	if(hip_position_flag == 0){
	}else if(hip_position_flag == 1){
		pose_content.hips.position[0]  =  bvh_object.clip.tracks[0].values[num_of_clip_pos + 0]  *bvh_scale ;
		pose_content.hips.position[1]  =  bvh_object.clip.tracks[0].values[num_of_clip_pos + 1]  *bvh_scale ;
		pose_content.hips.position[2]  =  bvh_object.clip.tracks[0].values[num_of_clip_pos + 2]  *bvh_scale ;
	}

	if(hip_rotation_flag == 0){
	// まずbvhのrotation情報を取り出す
	// bvh内のrotation情報に体の角度を足す
	// positionが，その前のclipと差分があれば，その差分を計算して，
	// 現在値を算出しなおす（方向差分の考慮）
	//
	}else if(hip_position_flag == 1){
	}





}




//////////////////////////////////////////
/////////////////////////////////////////


	function body_pose_set(t,  bvh_object,  num_of_clip, pose_content, nickname,final,head_flag){
		t.end_of_clips_array[nickname] = final;
		Object.keys(pose_content).forEach((key) => {
			for(let i=0 ; i< t.bone_names.length; i++){

				if( key == "head" || key == "neck"){

					if(head_flag == 0){
					}else{
						input_rotation(pose_content[key].rotation,  t.pose_assign[nickname][i] ,bvh_object,num_of_clip);
					}


				}else if( key == "hips"){   // not "hip" !!!

					if(hip_rotation_flag == 0){
					}else if(hip_rotation_flag == 1){
						input_rotation(pose_content[key].rotation,  t.pose_assign[nickname][i] ,bvh_object,num_of_clip);
					}


				}else if( key == t.bone_names[i] ){
					input_rotation(pose_content[key].rotation,  t.pose_assign[nickname][i] ,bvh_object,num_of_clip);
				}
			}
		});




// ここのnicknameを書き換え？？
//		let this_vrm = character_scene_array[nickname];
	
	t._vrm.humanoid.setPose(pose_content); // assign pose
	let this_csn	=  t._scene;
	let this_cam	=  t._camera;
	let this_rend	=  t._renderer;

	this_rend.render(this_csn, this_cam);




	}

/*
	function position_return(nickname){
		let this_vrm = character_scene_array[nickname];
		this_vrm.humanoid.getBoneNode( THREE.VRMSchema.HumanoidBoneName.Hips).position.set(
									character_object_array[nickname].x,
									character_object_array[nickname].y,
									character_object_array[nickname].z );

//									characters_current_position[nickname][0],
//									characters_current_position[nickname][1],
//									characters_current_position[nickname][2]  );
		rendering();
	}
*/


	function input_rotation(object, num_parts, bvh_object, num_clip){
		if(num_parts== undefined || num_parts == null  || num_parts == -1 || isNaN(num_parts)  ){
		}else{
			let sign0 = -1;
			let sign1 =  1;
			let sign2 = -1;
			let sign3 =  1;
			try{
			
				if(bvh_object.clip.tracks[  num_parts  ].values === undefined ){
					console.log("eeeeeerrrr");
				}else{
					object[0]  =  sign0 * bvh_object.clip.tracks[  num_parts  ].values[num_clip + 0];
					object[1]  =  sign1 * bvh_object.clip.tracks[  num_parts  ].values[num_clip + 1];
					object[2]  =  sign2 * bvh_object.clip.tracks[  num_parts  ].values[num_clip + 2];
					object[3]  =  sign3 * bvh_object.clip.tracks[  num_parts  ].values[num_clip + 3];
				}
			}catch(e){
				console.log(e);
//				console.log(bvh_object.clip.tracks);
				console.log(num_parts, num_clip);
			}
		}
	}

















}



stop_bvh_loop(nickname){
	this.character_loop_flag[nickname] = 0;
}

stop_bvh(t,nickname){
	t.character_loop_flag[nickname] = 0;
	t.clear_timeout_bvh(t, nickname);
}

clear_timeout_bvh(t, nickname){
	if(t.number_of_clip_array[nickname] == null || t.number_of_clip_array[nickname] === "undefined" ){
	}else{
		for(let c = 0;  c < t.number_of_clip_array[nickname];   c++){
			if(t.timeout_array[nickname][c] !=null){
				clearTimeout( t.timeout_array[nickname][c] );
			}
		}
	}
}









loadMixamoAnimation( url, vrm ,t) {

let my_t =t;
////	return loader.loadAsync( url ).then( ( asset ) => {

console.log("loadmixani", url,vrm);

	const loader = new FBXLoader(); // A loader which loads FBX

	let tracks = new Array(); // KeyframeTracks compatible with VRM will be added here
	let clip = null;
	
	let counter=0;	

	loader.load( url ,  ( asset ) => {

console.log("asset.animations",asset.animations);

		clip = THREE.AnimationClip.findByName( asset.animations, 'mixamo.com' ); // extract the AnimationClip

		const restRotationInverse = new THREE.Quaternion();
		const parentRestWorldRotation = new THREE.Quaternion();
		const _quatA = new THREE.Quaternion();
		const _vec3 = new THREE.Vector3();

		// Adjust with reference to hips height.
		const motionHipsHeight = asset.getObjectByName( 'mixamorigHips' ).position.y;
		const vrmHipsHeight = vrm.humanoid.normalizedRestPose.hips.position[ 1 ];
		const hipsPositionScale = vrmHipsHeight / motionHipsHeight;

		clip.tracks.forEach( ( track ) => {
console.log("clip.tracks",clip.tracks,track);

			// Convert each tracks for VRM use, and push to `tracks`
			const trackSplitted = track.name.split( '.' );
			const mixamoRigName = trackSplitted[ 0 ];
			const vrmBoneName = mixamoVRMRigMap[ mixamoRigName ];
			const vrmNodeName = vrm.humanoid?.getNormalizedBoneNode( vrmBoneName )?.name;
			const mixamoRigNode = asset.getObjectByName( mixamoRigName );

			if ( vrmNodeName != null ) {
console.log("vrmNodeName",vrmNodeName);
				const propertyName = trackSplitted[ 1 ];

				// Store rotations of rest-pose.
				mixamoRigNode.getWorldQuaternion( restRotationInverse ).invert();
				mixamoRigNode.parent.getWorldQuaternion( parentRestWorldRotation );
console.log(THREE.QuaternionKeyframeTrack );
	if(counter != 0){
//				if ( track instanceof THREE.QuaternionKeyframeTrack ) {
console.log("tracksss",track);
					// Retarget rotation of mixamoRig to NormalizedBone.
					for ( let i = 0; i < track.values.length; i += 4 ) {

						const flatQuaternion = track.values.slice( i, i + 4 );

						_quatA.fromArray( flatQuaternion );

						// 親のレスト時ワールド回転 * トラックの回転 * レスト時ワールド回転の逆
						_quatA
							.premultiply( parentRestWorldRotation )
							.multiply( restRotationInverse );

						_quatA.toArray( flatQuaternion );

						flatQuaternion.forEach( ( v, index ) => {

							track.values[ index + i ] = v;

						} );

					}

console.log(";;",tracks);
					tracks.push(
						new THREE.QuaternionKeyframeTrack(
							`${vrmNodeName}.${propertyName}`,
							track.times,
							track.values.map( ( v, i ) => ( vrm.meta?.metaVersion === '0' && i % 2 === 0 ? - v : v ) ),
						),
					);



//				} else if ( track instanceof THREE.VectorKeyframeTrack ) {
	}else{
counter++;
console.log(";;",tracks, vrmNodeName, propertyName);
			const value = track.values.map( ( v, i ) => ( vrm.meta?.metaVersion === '0' && i % 3 !== 1 ? - v : v ) * hipsPositionScale );
			tracks.push( new THREE.VectorKeyframeTrack( `${vrmNodeName}.${propertyName}`, track.times, value ) );

				}


			}

		} );

	my_t._ret =  new THREE.AnimationClip( 'vrmAnimation', clip.duration, tracks );
	console.log("_ret",my_t._ret);

//	return ret;
	
	} );




}



}

// class end
module.exports = Scratch3Character;


///export  default Scratch3Character;

